import axios from 'axios'
import api from './index'
import router from '../router'
import {
    clearCookie
} from '../util/celecookie'
/**
 *
 * @type {{}}
 */
axios.defaults.timeout = 300000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charest=utf-8'
axios.interceptors.request.use(config => {
    // 判断是否有cmpycode
    // const cmpycode = localStorage.getItem('cmpycode');
    // if (cmpycode) {
    //   config.headers = {'AccessToken': cmpycode} // 后台接收的参数，后面我们将说明后台如何接收
    // } else {
    //   store.state.dispatch('CmpyinfoByReqdomain', reqDomainparams)
    // }
    return config
}, err => {
    return Promise.reject(err)
})
axios.interceptors.response.use(response => {
    if (response.data.status == '401') {
        sessionStorage.setItem('qydmInfo', '');
        clearCookie();
        router.replace({
            name: '登录'
        })
    }
    if (response.data.status == '778') {
        sessionStorage.setItem('qydmInfo', '');
        clearCookie()
        router.replace({
            name: '登录'
        })
    }
    return response
}, err => {
    return Promise.reject(err)
})
let apis = process.env.NODE_ENV === 'production' ? '' : '/apis'
let goods = apis + '/api/center/goods' // 线上 商品
let card = apis + '/api/center/card' // 线上 券卡
let order = apis + '/api/center/order' // 线上 订单
let delivery = apis + '/api/center/delivery' // 线上 发货
let base = apis + '/api/center/base' // 线上 其他
let common = apis + '/api/common' // 线上 基础（上传）
let birthcode = apis + '/api/center/gencode' // 线上 生码
let share = apis + '/api/center/share' // 线上 仓分享
let statistics = apis + '/api/center/statistics' // 线上 数据统计
let customize = apis + '/api/center/customize' // 线上 金世通接口
let cityDelivery = apis + '/api/city-delivery' // 线下 达达
let scheme = apis + '/api/scheme' // 线上
let doudian = apis + '/api/center/doudian' //线上
let anitemplate =apis+'/api/anitemplate' //线上
let new_delivery = apis + '/api/center/new_delivery'//发货
let xdh = apis + '/api/center/xdh' // 线上 蟹都汇经销商对账
let help = {
    indexcode: 'd69a28c899a147da94aadc0d8fa56890', //主页
    goodscode: '', //商品中心
    cardscode: '9daaf27328514460be90fd222bd0001a', //券卡中心
    ordercode: 'a9eca972a0484e5797c1442d8ad32706', //订单中心
    delivercode: '', //发货中心
    Marketingcode: '', //营销中心
    membercode: '', //会员中心
    Administrationcode: '8d86b50702b4485cb15da3341be7900a', //管理中心
    Traceabilitycode: '', //溯源中心
    datacode: '8e8bd705d7df4e10b9db83add5dee003', //数据报表
    sharingcode: '' //仓分享管理
}
let customizeJhw = '/apis/api/center/customize-jhw' // 临时使用
export default {
    GET_HELP: help,
    // 初始化接口 ------------------------------------------------------------------------------- 初始化接口
    // 编辑器图片上传路径
    UPLOADPICdd(params) {
      return api.fetch('post', `${common}/uploadPic`, params)
    },
    // 管理端登录发送验证码
    SENDCHECKCODEMSG(params) {
        return api.fetch('post', `${base}/checkcode/sendCheckCodeMsg`, params)
    },
    // 登录接口
    LOGIN(params) {
        return api.fetch('post', `${base}/flow/login`, params)
    },
    // 密码过于简单强制修改密码
    UPDPASSWORD(params) {
      return api.fetch('post', `${base}/updPassword`, params)
    },
    // 退出登录接口
    LOGOUT(params) {
        return api.fetch('post', `${base}/logout`, params)
    },
    // 获取企业基础配置
    GET_PUBCONFIGINFO(params) {
        return api.fetch('post', `${base}/getPubConfigInfo`, params)
    },
    // 获取企业订单配置信息
    GET_PUBORDERCONFIGINFO(params) {
        return api.fetch('post', `${base}/getPubOrderConfigInfo`, params)
    },
    // 获取企业营销配置信息
    GET_SYSMARINFO(params) {
        return api.fetch('post', `${base}/getSysMarInfo`, params)
    },
    // 获取预售基础服务配置
    GET_SYSPRESELLCONFIGINFO(params) {
        return api.fetch('post', `${base}/getSysPresellConfigInfo`, params)
    },
    // 获取预售各品牌个性配置信息
    GET_CARDSYSBASEINFO(params) {
        return api.fetch('post', `${base}/getCardSysBaseInfo`, params)
    },
    // 获取品牌列表
    GET_BRANDINFOLIST(params) {
        return api.fetch('post', `${base}/getBrandInfoList`, params)
    },
    // 获取品牌列表分页
    GET_BRANDINFOLISTBYPAGEBEAN(params) {
        return api.fetch('post', `${base}/getBrandInfoListByPagebean`, params)
    },
    // 系统配置-获取品牌列表
    GET_BRANDLIST(params) {
        return api.fetch('post', `${base}/cardsysbaseinfo/getBrandList`, params)
    },
    // 获取对应的支付参数配置
    GET_SYSPAYPARAINFO(params) {
        return api.fetch('post', `${base}/getSysPayParaInfo`, params)
    },
    // 首页接口 -------------------------------------------------------------------------------- 首页接口
    // 待处理事项数量统计
    PENDINGSTATISTICS(params) {
        return api.fetch('post', `${base}/homepage/pendingStatistics`, params)
    },
    // 企业合作概况统计
    COOPERATIONSTATISTICS(params) {
        return api.fetch('post', `${base}/homepage/cooperationStatistics`, params)
    },
    // 商品概况统计
    GOODSSTATISTICS(params) {
        return api.fetch('post', `${base}/homepage/goodsStatistics`, params)
    },
    // 礼品券卡概况统计
    CARDSSTATISTICS(params) {
        return api.fetch('post', `${base}/homepage/cardsStatistics`, params)
    },
    // 订单概况统计
    ORDERSTATISTICS(params) {
        return api.fetch('post', `${base}/homepage/orderStatistics`, params)
    },
    // 获取首页自定义设置
    GET_HOMEPAGESET(params) {
        return api.fetch('post', `${base}/homepage/getHomepageSet`, params)
    },
    // 保存首页自定义设置
    SAVEHOMEPAGESET(params) {
        return api.fetch('post', `${base}/homepage/saveHomepageSet`, params)
    },
    // 查询运维人员信息
    GET_OPERINFO(params) {
        return api.fetch('post', `${base}/homepage/getOperinfo`, params)
    },
    // 通用接口 -------------------------------------------------------------------------------- 通用接口
    // 根据上级编号查找下级地址列表
    GET_ADDRESSBYCODE(params) {
        return api.fetch('post', `${base}/address/getAddressByCode`, params)
    },
    // // 会员列表查询
    // GET_MEMBERLIST(params) {
    //     return api.fetch('post', `${base}/memberService/getMemberList`, params)
    // },
    // 查询品牌信息
    GET_BRANDINFO(params) {
        return api.fetch('post', `${base}/getBrandInfo`, params)
    },
    // 获取域名配置列表
    GET_DOMAINLIST(params) {
        return api.fetch('post', `${base}/getDomainList`, params)
    },
    // 商品管理接口 -------------------------------------------------------------------------------- 商品管理接口
    // 获取商品分类列表
    GET_CLASSIFYLIST(params) {
        return api.fetch('post', `${goods}/classify/getClassifyList`, params)
    },
    // 保存商品分类（自动创建默认分类）
    SAVECLASSIFY(params) {
        return api.fetch('post', `${goods}/classify/saveClassify`, params)
    },
    // 校验分类名称是否重复
    CLASSIFY_CHECKNAME(params) {
        return api.fetch('post', `${goods}/classify/checkName`, params)
    },
    // 查询分类详情信息
    CLASSIFYDETAIL(params) {
        return api.fetch('post', `${goods}/classify/classifyDetail`, params)
    },
    // 删除商品分类
    DELETECLASSIFY(params) {
        return api.fetch('post', `${goods}/classify/deleteClassify`, params)
    },
    // 获取商品与规格信息列表，规格与商品联表
    GET_GOODSLIST(params) {
        return api.fetch('post', `${goods}/goods/getGoodsList`, params)
    },
    // 保存商品基础信息
    SAVEBASIC(params) {
        return api.fetch('post', `${goods}/goods/saveBasic`, params)
    },
    // 校验 商品/规格 名称是否重复
    GOODS_CHECKNAME(params) {
        return api.fetch('post', `${goods}/goods/checkName`, params)
    },
    // 保存商品规格信息
    SAVEKINDINFO(params) {
        return api.fetch('post', `${goods}/goods/saveKindinfo`, params)
    },
    // 查询商品基础信息详情
    GOODS_BASICDETAIL(params) {
        return api.fetch('post', `${goods}/goods/basicDetail`, params)
    },
    // 查询商品规格信息详情
    KINDINFODETAIL(params) {
        return api.fetch('post', `${goods}/goods/kindinfoDetail`, params)
    },
    // 查询券卡商品定制规则信息
    CARDKINDINFO(params) {
        return api.fetch('post', `${goods}/goods/cardkindinfo`, params)
    },
    // 查询商品规格列表
    GOODS_KINDINFOS(params) {
        return api.fetch('post', `${goods}/goods/goodskindinfos`, params)
    },
    // 批量上下架商品/规格
    BATCHUPDSTATUS(params) {
        return api.fetch('post', `${goods}/goods/batchUpdStatus`, params)
    },
    // 根据实物商品生成礼品券
    CREATEVOUCHERS(params) {
        return api.fetch('post', `${goods}/goods/createVouchers`, params)
    },
    // 删除商品或者规格
    DELETEGOODS(params) {
        return api.fetch('post', `${goods}/goods/deleteGoods`, params)
    },
    // 查询商品规格销售渠道信息
    GET_THIRDMALLINFO(params) {
        return api.fetch('post', `${goods}/goods/getThirdMallInfo`, params)
    },
    // 查询商品配图信息
    GET_GOODSPICINFO(params) {
        return api.fetch('post', `${goods}/goods/getGoodsPicInfo`, params)
    },
    // 查询商品富文本详细信息
    GET_GOODSDET(params) {
        return api.fetch('post', `${goods}/goods/getGoodsDet`, params)
    },
    // 查询商品配送范围
    GET_DISRANGE(params) {
        return api.fetch('post', `${goods}/goods/getDisrange`, params)
    },
    // 获取指定规格的库存（实物商品）
    GET_INVBYKINDCODE(params) {
        return api.fetch('post', `${goods}/inventory/getInvByKindcode`, params)
    },
    // 设置规格库存（加/减）
    SETINVINFO(params) {
        return api.fetch('post', `${goods}/inventory/setInvinfo`, params)
    },
    // 获取品类列表
    GET_PCATEINFO(params) {
        return api.fetch('post', `${goods}/pcateinfo/getPcateinfo`, params)
    },
    // 查询商品名称是否已生成礼品券
    CHECKVOUCHERSEXIST(params) {
        return api.fetch('post', `${goods}/goods/checkVouchersExist`, params)
    },
    // 查询商品列表(不含规格信息)
    GET_GOODSLISTWITHOUTKIND(params) {
        return api.fetch('post', `${goods}/goods/getGoodsListWithoutKind`, params)
    },
    // 批量修改商品分类
    BATCHCATEGORY(params) {
        return api.fetch('post', `${goods}/goods/batchCategory`, params)
    },
    // 礼品券卡管理接口 -------------------------------------------------------------------------------- 礼品券卡管理接口
    // 根据券卡编码查询券卡详细信息
    GET_CARDINFODET(params) {
        return api.fetch('post', `${card}/codequery/getCardinfoDet`, params)
    },
    //根据券卡编码和密码验证卡券真假
    CHECKCARDBETRUE(params) {
        return api.fetch('post', `${card}/codequery/checkCardBeTrue`, params)
    },
    // 查询可选商品专区列表
    GET_OPTGOODSINFO(params) {
        return api.fetch('post', `${card}/codequery/getOptgoodsinfo`, params)
    },
    // 根据券卡编码查询券卡相关操作记录列表
    GET_RECORDINFOLIST(params) {
        return api.fetch('post', `${card}/codequery/getRecordinfoList`, params)
    },
    // 查询券卡关联的所有母单号（后端接口为1.3）
    GET_RELORDERNOS(params) {
        return api.fetch('post', `${card}/codequery/getRelOrdernos`, params)
    },
    // 查询礼品券卡管理订单的所有关联券卡列表
    GET_RELCARDSLIST(params) {
        return api.fetch('post', `${card}/codequery/getRelcardsList`, params)
    },
    // 查询绑定自提门店
    GET_STORELISTBYCODE(params) {
        return api.fetch('post', `${card}/codequery/getStoreListByCode`, params)
    },
    // 获取匹配的券卡类型（最多 30 条）
    GET_CARDKIND(params) {
        return api.fetch('post', `${card}/codequery/getCardkind`, params)
    },
    // 券卡操作页面初始化接口
    CODEINFOINIT(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoInit`, params)
    },
    // 礼品券卡单码验证接口
    ONECODEVALID(params) {
        return api.fetch('post', `${card}/codeinfo/oneCodeValid`, params)
    },
    // 序列号验证接口
    SERIALSCAN(params) {
        return api.fetch('post', `${card}/codeinfo/serialScan`, params)
    },
    // 根据编码文本链接获取编码内容并返回验证结果
    FILECODESVALID(params) {
        return api.fetch('post', `${card}/codeinfo/fileCodesValid`, params)
    },
    // 移除已验证券卡信息接口
    REMOVEFROMSESSION(params) {
        return api.fetch('post', `${card}/codeinfo/removeFromSession`, params)
    },
    // 礼品券卡出库提交接口
    CODEINFOOUTOPER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoOutOper`, params)
    },
    // 礼品券卡激活提交接口
    CODEINFOACTOPER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoActOper`, params)
    },
    // 礼品券卡后续分销提交接口
    CODEINFODISTOPER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoDistOper`, params)
    },
    // 礼品券卡回收操作提交接口
    CODEINFORECYCLEOPER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoRecycleOper`, params)
    },
    // 卡包券卡回收操作提交接口
    BAGCODEINFORECYCLEOPER(params) {
        return api.fetch('post', `${card}/codeinfo/bagcodeinfoRecycleOper`, params)
    },
    // 礼品券卡暂停/恢复操作提交接口
    CODEINFOSUSPENDORRECOVER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoSuspendOrRecover`, params)
    },
    ECODEINFOSUSPENDORRECOVER(params) {
        return api.fetch('post', `${card}/cardbatch/ecodeinfoSuspendOrRecover`, params)
    },
    SMSBATCHSINGLECARDCYCLE(params) {
      return api.fetch('post', `${card}/ecodeinfo/smsBatchSingleCardCycle`, params)
    },
    // 礼品券卡作废操作提交接口
    CODEINFOINVALID(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoInvalid`, params)
    },
    // 礼品券卡快捷修改提交接口
    CODEINFOQUICKUPDATEOPER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoQuickupdateOper`, params)
    },
    // 卡包券卡快捷修改提交接口（保存记录）
    BAGCODEINFOSUSPENDORRECOVER(params) {
        return api.fetch('post', `${card}/codeinfo/bagcodeinfoQuickupdateOper`, params)
    },
    // 礼品券卡回收折现操作提交接口
    CODEINFODISCOUNTOPER(params) {
        return api.fetch('post', `${card}/codeinfo/codeinfoDiscountOper`, params)
    },
    // 分销券卡现金收款操作提交接口
    CODEINFOCASHOPER(params) {
        return api.fetch('post', `${card}/distributor/codeinfoCashOper`, params)
    },
    // 分销券卡分销回收操作提交接口
    CODEINFODISRECYOPER(params) {
        return api.fetch('post', `${card}/distributor/codeinfoDisrecyOper`, params)
    },
    // 礼品券卡/消费卡操作批次列表查询接口
    GET_CARDBATCHLIST(params) {
        return api.fetch('post', `${card}/cardbatch/getCardBatchList`, params)
    },
    // 统计礼品券卡/消费卡—出库/激活批次内券卡使用情况
    GET_CARDBATCHSTATISTICS(params) {
        return api.fetch('post', `${card}/cardbatch/getCardBatchStatistics`, params)
    },
    // 查询礼品券卡/消费卡批次内编码详情列表接口
    GET_CARDBATCHCODELIST(params) {
        return api.fetch('post', `${card}/cardbatch/getCardBatchCodeList`, params)
    },
    //回收批次详情
    GET_MDHUISHOUCODELIST(params) {
      return api.fetch('post', `${card}/cardbatch/getMdHuishouCodeList`, params)
   },
    // 查询礼品券卡批次内可操作(出库/修改/回收/暂停/恢复)数量接口
    GET_OPERNUM(params) {
        return api.fetch('post', `${card}/cardbatch/getOperNum`, params)
    },
    // 查询礼品券卡/消费卡批次记录详情(批次修改初始化页面调用)
    GET_CARDBATCHDETAIL(params) {
        return api.fetch('post', `${card}/cardbatch/getCardbatchDetail`, params)
    },
    // 礼品券卡批次修改提交
    UPDATECARDBATCH(params) {
        return api.fetch('post', `${card}/cardbatch/updateCardbatch`, params)
    },
    // 礼品券卡批次出库提交
    CARDBATCHOUT(params) {
        return api.fetch('post', `${card}/cardbatch/cardbatchOut`, params)
    },
    // 礼品券卡批次回收操作
    CARDBATCHRECYCLE(params) {
        return api.fetch('post', `${card}/cardbatch/cardbatchRecycle`, params)
    },
    //兑换礼券出库批次批量修改有效期
    BATCHUPDATEVALDATE(params) {
        return api.fetch('post', `${card}/cardbatch/batchUpdateValdate`, params)
    },
    // 礼品券卡批次暂停/恢复操作
    BATCHOTHEROPER(params) {
        return api.fetch('post', `${card}/cardbatch/batchOtherOper`, params)
    },
    // 礼品券卡操作批次结果汇总
    GET_BATCHRESULT(params) {
        return api.fetch('post', `${card}/cardbatch/getBatchResult`, params)
    },
    // 统计后续分销的当前批次操作的券卡数量
    TOTALCODESUBNUM(params) {
        return api.fetch('post', `${card}/cardbatch/totalcodesubnum`, params)
    },
    // 优惠券单码验证接口
    COUPON_ONECODEVALID(params) {
        return api.fetch('post', `${card}/coupon/oneCodeValid`, params)
    },
    // 优惠券出库提交
    COUPON_OUTOPER(params) {
        return api.fetch('post', `${card}/coupon/couponOutOper`, params)
    },
    // 优惠券回收操作提交接口
    COUPON_RECYCLEOPER(params) {
        return api.fetch('post', `${card}/coupon/couponRecycleOper`, params)
    },
    // 优惠券暂停/恢复操作提交接口
    COUPON_SUSPENDORRECOVER(params) {
        return api.fetch('post', `${card}/coupon/couponSuspendOrRecover`, params)
    },
    // 优惠券作废操作提交接口
    COUPON_INVALID(params) {
        return api.fetch('post', `${card}/coupon/couponInvalid`, params)
    },
    // 优惠券操作批次列表查询接口
    GET_COUPONBATCHLIST(params) {
        return api.fetch('post', `${card}/couponbatch/getCouponBatchList`, params)
    },
    // 统计优惠券出库批次内券卡使用情况
    GET_COUPONBATCHSTATISTICS(params) {
        return api.fetch('post', `${card}/couponbatch/getCouponBatchStatistics`, params)
    },
    // 查询优惠券批次内编码详情列表接口
    GET_COUPONBATCHCODELIST(params) {
        return api.fetch('post', `${card}/couponbatch/getCouponBatchCodeList`, params)
    },
    // 查询优惠券批次内可操作(出库/修改/回收/暂停/恢复)数量接口
    GET_COUPONOPERNUM(params) {
        return api.fetch('post', `${card}/couponbatch/getOperNum`, params)
    },
    // 查询优惠券批次记录详情(批次修改初始化页面调用)
    GET_COUPONBATCHDETAIL(params) {
        return api.fetch('post', `${card}/couponbatch/getCouponbatchDetail`, params)
    },
    // 优惠券批次修改
    UPDATECOUPONBATCH(params) {
        return api.fetch('post', `${card}/couponbatch/updateCouponBatch`, params)
    },
    // 优惠券批次出库提交
    COUPON_BATCHOUTOPER(params) {
        return api.fetch('post', `${card}/couponbatch/couponBatchOutOper`, params)
    },
    // 优惠券批次回收操作
    COUPON_BATCHRECYCLE(params) {
        return api.fetch('post', `${card}/couponbatch/couponbatchRecycle`, params)
    },
    // 优惠券批次暂停/恢复操作
    COUPON_BATCHOTHEROPER(params) {
        return api.fetch('post', `${card}/couponbatch/batchOtherOper`, params)
    },
    // 消费卡单码验证接口
    PRECARD_ONECODEVALID(params) {
        return api.fetch('post', `${card}/precard/oneCodeValid`, params)
    },
    // 消费卡出库提交接口
    PRECARD_OUTOPER(params) {
        return api.fetch('post', `${card}/precard/precardOutOper`, params)
    },
    // 消费卡回收操作提交接口
    PRECARD_RECYCLEOPER(params) {
        return api.fetch('post', `${card}/precard/precardRecycleOper`, params)
    },
    // 消费卡暂停/恢复操作提交接口
    PRECARD_SUSPENDORRECOVER(params) {
        return api.fetch('post', `${card}/precard/precardSuspendOrRecover`, params)
    },
    // 消费卡作废操作提交接口
    PRECARD_INVALID(params) {
        return api.fetch('post', `${card}/precard/precardInvalid`, params)
    },
    // 消费卡批次修改提交
    UPDATEPRECARDBATCH(params) {
        return api.fetch('post', `${card}/precardbatch/updatePrecardbatch`, params)
    },
    // 消费卡批次出库提交
    PRECARD_BATCHOUTOPER(params) {
        return api.fetch('post', `${card}/precardbatch/precardbatchOutOper`, params)
    },
    // 消费卡批次回收操作
    PRECARD_BATCHRECYCLE(params) {
        return api.fetch('post', `${card}/precardbatch/precardbatchRecycle`, params)
    },
    // 消费卡批次修改提交
    PRECARD_BATCHOTHEROPER(params) {
        return api.fetch('post', `${card}/precardbatch/batchOtherOper`, params)
    },
    // 礼品券卡电子券页面初始化接口
    ECODEINFOINIT(params) {
        return api.fetch('post', `${card}/ecodeinfo/ecodeinfoInit`, params)
    },
    // 礼品券卡电子券手机号验证接口
    ECODEINFOPHONESCAN(params) {
        return api.fetch('post', `${card}/ecodeinfo/ecodeinfoPhoneScan`, params)
    },
    // 获取当前企业电子券余量
    GET_NUMBEROFUNUSEDECODEINFO(params) {
        return api.fetch('post', `${card}/ecodeinfo/getNumberOfUnusedEcodeinfo`, params)
    },
    // 移除已验证电子券缓存接口
    ECODE_REMOVEFROMSESSION(params) {
        return api.fetch('post', `${card}/ecodeinfo/removeFromSession`, params)
    },
    // 礼品券卡电子券出库提交
    ECODEINFOOUTOPER(params) {
        return api.fetch('post', `${card}/ecodeinfo/ecodeinfoOutOper`, params)
    },
    // 礼品券卡电子券出库短信重发
    RESENDMSG(params) {
        return api.fetch('post', `${card}/ecodeinfo/resendMsg`, params)
    },
    // 礼品券卡分销付款记录列表查询接口
    CARDDISPAYINFOLIST(params) {
        return api.fetch('post', `${card}/distributor/carddispayinfoList`, params)
    },
    // 礼品券卡分销付款记录编码详情列表查询接口
    GET_CARDDISPAYINFODETAIL(params) {
        return api.fetch('post', `${card}/distributor/getCarddispayinfoDetail`, params)
    },
    // 生成分销付款记录详细列表数据的下载链接URL
    GET_CARDDISPAYINFOLISTURL(params) {
        return api.fetch('post', `${card}/distributor/getUrlByCarddispayDetail`, params)
    },
    // 门店回收
    MDHUISHOUOPER(params) {
        return api.fetch('post', `${card}/codeinfo/mdHuishouOper`, params)
    },
    //查询生码记录列表信息
    GET_GENCODERECORDLIST(params) {
        return api.fetch('post', `${birthcode}/gencode/getGencoderecordList`, params)
    },
    // 生码页面初始化
    GENCODEINIT(params) {
        return api.fetch('post', `${birthcode}/gencode/gencodeInit`, params)
    },
    // 发送验证码
    SENDVALIDATECODE(params) {
        return api.fetch('post', `${birthcode}/gencode/sendValidatecode`, params)
    },
    // 提交生码操作
    SUBGENCODEAPPLY(params) {
        return api.fetch('post', `${birthcode}/gencode/subGencodeApply`, params)
    },
    // 判断生码下载
    CHECKCODEPASS(params) {
        return api.fetch('post', `${birthcode}/gencode/checkCodePass`, params)
    },
    // 生码文件下载
    DOWNLOADTXT(params) {
        return api.fetch('post', `${birthcode}/gencode/downloadTxt`, params)
    },
    // 查询品规记录列表信息
    GET_SPECIFICATIONSLIST(params) {
        return api.fetch('post', `${birthcode}/specifications/getSpecificationsList`, params)
    },
    // 获取品规信息
    GET_SPECIFICATIONS(params) {
        return api.fetch('post', `${birthcode}/specifications/getSpecifications`, params)
    },
    // 新增或编辑品规信息
    SAVESPECIFICATIONS(params) {
        return api.fetch('post', `${birthcode}/specifications/saveSpecifications`, params)
    },
    // 订单管理接口 -------------------------------------------------------------------------------- 订单管理接口
    // 优惠券校验
    CHECKCOUPONVALID(params) {
        return api.fetch('post', `${order}/couponpick/checkCouponValid`, params)
    },
    // 优惠券核销
    TOSUBMIT(params) {
        return api.fetch('post', `${order}/couponpick/tosubmit`, params)
    },
    // 序列号段核销
    CARDPICKBYSERIALSANDSUBORDER(params) {
        return api.fetch('post', `${order}/pick/cardPickBySerialsAndSubOrder`, params)
    },
    // 电话、客服 -提货页面初始化
    INITIALIZE(params) {
        return api.fetch('post', `${order}/pick/initialize`, params)
    },
    // 校验已设置商品是否满足配送范围
    VALCITYANDOKSET(params) {
        return api.fetch('post', `${order}/pick/valCityAndOkSet`, params)
    },
    // 电话、客服 - 提货券卡验证
    VALIDATE(params) {
        return api.fetch('post', `${order}/pick/validate`, params)
    },
    // 已验证券卡提货商品设置
    SETCARDGOODS(params) {
        return api.fetch('post', `${order}/pick/setcardgoods`, params)
    },
    // 移除已验证券卡列表中的券卡
    REMOVEVALIDATEDCARD(params) {
        return api.fetch('post', `${order}/pick/removevalidatedcard`, params)
    },
    // 已验证券卡，消耗次数设置
    SETCARDUSENUM(params) {
        return api.fetch('post', `${order}/pick/setcardusenum`, params)
    },
    // 根据券卡编号，获取已验证券卡信息
    GET_VALIDATEDCARDINFO(params) {
        return api.fetch('post', `${order}/pick/getvalidatedcardinfo`, params)
    },
    // 获取历史提货地址记录
    GET_PICKADDRESSPASTRECORDS(params) {
        return api.fetch('post', `${order}/pick/getpickaddresspastrecords`, params)
    },
    // 获取所有券卡已经设置的商品的提货日期汇总
    GET_SELECTEDGOODSSALESDATES(params) {
        return api.fetch('post', `${order}/pick/getselectedgoodssalesdates`, params)
    },
    // 已验证券卡中是否存在地图配送商品
    HASRANGEGOODS(params) {
        return api.fetch('post', `${order}/pick/hasrangegoods`, params)
    },
    // 电话、客服 - 提货订单提交
    SUBMITORDER(params) {
        return api.fetch('post', `${order}/pick/submitPreOrder`, params)
    },
    // 金世尊电话、客服 - 提货订单提交
    JINSHIZUNSUBMITORDER(params) {
        return api.fetch('post', `${order}/pick/jszSelfPickUpSubmitPreOrder`, params)
    },
    // 获取订单券卡可选专区信息
    GET_ORDERCARDINFO(params) {
        return api.fetch('post', `${order}/pick/getpickcardinfobyordernoandcode`, params)
    },
    // 已验证券卡中是否存阿里渠道券卡
    ISALICHANNEL(params) {
        return api.fetch('post', `${order}/pick/isAliChannel`, params)
    },
    // 发送提货验证短信
    SENDALICHANNELSHORTMSG(params) {
        return api.fetch('post', `${order}/pick/sendAliChannelShortMsg`, params)
    },
    // 发送提货验证短信
    VERIFYALICHANNELSHORTMSG(params) {
        return api.fetch('post', `${order}/pick/verifyAliChannelShortMsg`, params)
    },
    // 获取指定商品集合是否存在地图配送商品
    HASRANGINGOODS(params) {
        return api.fetch('post', `${order}/pick/hasRangInGoods`, params)
    },
    // 获取订单基础信息列表数据
    GET_ORDERLIST(params) {
        return api.fetch('post', `${order}/store/order/getOrderBaseInfoList`, params)
    },
    // 获取子单列表
    GET_ORDERCHLIDLIST(params) {
        return api.fetch('post', `${order}/order/getChildOrderinfoList`, params)
    },
    // 获取订单基础详细信息
    GET_ORDERINFODETAIL(params) {
        return api.fetch('post', `${order}/store/order/getOrderinfoBaseDetail`, params)
    },
    // 获取订单付款信息
    GET_ORDERPAYINFO(params) {
        return api.fetch('post', `${order}/store/order/getOrderPayInfo`, params)
    },
    // 获取订单收货信息
    GET_RECEIVERINFO(params) {
        return api.fetch('post', `${order}/store/order/getOrderReceiverinfo`, params)
    },
    // 获取订单信息修改记录列表数据
    GET_ORDMODIFYRECORDLIST(params) {
        return api.fetch('post', `${order}/store/order/getOrderinfoModifyRecordList`, params)
    },
    // 获取订单相关券卡及提货商品信息
    GET_ORDCARDSANDGOODSINFO(params) {
        return api.fetch('post', `${order}/store/order/getOrderRelatedCardInfos`, params)
    },
    // 获取可指派订单列表
    GET_ORDERASSIGNLIST(params) {
        return api.fetch('post', `${order}/order/getOrderAssignList`, params)
    },
    // 修改订单信息（普通修改）
    UPDATEORDERCOMMON(params) {
        return api.fetch('post', `${order}/store/order/updateOrderInfoNormal`, params)
    },
    // 获取订单商品详细
    GETORDERGOODSSALEDET(params) {
        return api.fetch('post', `${order}/order/getOrdergoodssaledet`, params)
    },
    // 订单取消
    CANCELORDER(params) {
        return api.fetch('post', `${order}/store/order/cancelOrder`, params)
    },
    // 订单结单（正常，异常结单）
    FINISHECARDORDER(params) {
        return api.fetch('post', `${order}/store/order/finishOrder`, params)
    },
    // 获取总部派单记录
    GET_ORDERDESINFOLIST(params) {
        return api.fetch('post', `${order}/store/order/getOrderdesinfoList`, params)
    },
    // 修改子单期望发货日期
    UPDATERECVDATE(params) {
        return api.fetch('post', `${order}/order/updateRecvdate`, params)
    },
    // 订单高级修改
    UPDATEORDERINFOSTATE(params) {
        return api.fetch('post', `${order}/order/updateOrderInfoState`, params)
    },
    // 订单退回
    GETMONEYANDOVERORDER(params) {
        return api.fetch('post', `${order}/store/order/rejectAssignOrder`, params)
    },
    // 修改订单备注
    MODIFYORDERINFOMEMO(params) {
        return api.fetch('post', `${order}/store/order/modifyOrderInfoMemo`, params)
    },
    // 通过规格编号获取商品
    GET_GOODSINFOBYKINDCODES(params) {
        return api.fetch('post', `${order}/store/order/getGoodsinfoByKindcodes`, params)
    },
    // 合作订单授信额度扣除
    DEDUCTLINES(params) {
        return api.fetch('post', `${order}/order/deductLines`, params)
    },
    // 修改订单实际支付金额/邮费
    UPDATEORDERAMOUNT(params) {
        return api.fetch('post', `${order}/order/updateOrderAmount`, params)
    },
    // 获取可配货订单列表
    GET_ORDERCANDELIVERYLIST(params) {
        return api.fetch('post', `${order}/order/getOrderCanDeliveryList`, params)
    },
    // 获取导出订单URL
    GET_ORDEREXPORTURL(params) {
        return api.fetch('post', `${order}/order/getorderexporturl`, params)
    },
    // 批量配货
    ASSIGNDELIVERYORDER(params) {
        return api.fetch('post', `${order}/order/orderDistribute`, params)
    },
    // 获取券卡可选择商品信息（券卡提货、订单修改时都需要用到）
    GET_ORDEROPTGOODSINFO(params) {
        return api.fetch('post', `${order}/order/getOptgoodsInfo`, params)
    },
    // 获取订单/快递查询的母单列表数据
    QUERYORDERANDEXP(params) {
        return api.fetch('post', `${order}/order/queryOrderAndExp`, params)
    },
    // 获取订单/快递查询的快递列表数据
    QUERYORDEREXPINFOS(params) {
        return api.fetch('post', `${order}/order/queryOrderExpinfos`, params)
    },
    // 获取订单/快递查询的快递详细数据
    FINDEXPINFODETAIL(params) {
        return api.fetch('post', `${order}/order/findExpinfoDetail`, params)
    },
    // 获取提货订单自提转送货邮费
    GET_CONVERORDERDELIVERYDELIMODEPOSTAGE(params) {
        return api.fetch('post', `${order}/order/getConverOrderDeliveryDelimodePostage`, params)
    },
  // 发货管理接口 -------------------------------------------------------------------------------- 发货管理接口
    //一键发货
    AUTODELIVERY(params) {
      return api.fetch('post', `${new_delivery}/pre/autoDelivery`, params)
    },
    // 获取待发货订单列表
    LISTPENORDSHIPPED(params) {
      return api.fetch('post', `${delivery}/pre/listPenordshipped`, params)
    },
    //获取规格内容
    LISTGOODSKINDINFOBYORDERNO(params) {
        return api.fetch('post', `${delivery}/pre/listGoodskindifoByOrderno`, params)
    },
    // 检索发货/勾选发货（根据检索条件生成快递以及快递批次）
    ORDERPRINT(params) {
        return api.fetch('post', `${delivery}/pre/orderPrint`, params)
    },
    // 订单详情（包括订单关联券卡详情）
    FINDORDERDETAIL(params) {
        return api.fetch('post', `${delivery}/pre/findOrderDetail`, params)
    },
    // 查看配送区域
    SHOWDISRANGE(params) {
        return api.fetch('post', `${delivery}/pre/showDisrange`, params)
    },
    // 编辑订单打印备注
    UPDSELLERMEMO(params) {
        return api.fetch('post', `${delivery}/pre/updSellermemo`, params)
    },
    // 获取开通的物流列表
    GET_SHOWPRINT(params) {
        return api.fetch('post', `${delivery}/pre/getShowPrint`, params)
    },
    //统计待发货订单的商品列表
    STATISTICSGOODSOFORDER(params) {
        return api.fetch('post', `${delivery}/pre/statisticsGoodsOfOrder`, params)
    },
    //导出统计待发货订单的商品列表
    STATISTICSGOODSEXPORT(params) {
        return api.fetch('post', `${delivery}/pre/statisticsGoodsExport`, params)
    },
    // 快递打印批次列表
    LISTEXPGENBATCH(params) {
        return api.fetch('post', `${delivery}/print/listExpgenbatch`, params)
    },
    // 快递打印批次详情列表
    FINDEXPGENBATCHDETAIL(params) {
        return api.fetch('post', `${delivery}/print/findExpgenbatchDetail`, params)
    },
    // 根据一个或多个批次获取指定打印快递列表
    FINDBATCHPRINT(params) {
        return api.fetch('post', `${delivery}/print/findBatchPrint`, params)
    },
    // 导出即发货（一个或多个批次）
    EXPORTEXPGENBATCHDELIVER(params) {
        return api.fetch('post', `${delivery}/print/exportExpgenbatchDeliver`, params)
    },
    // 导出待发货（一个或多个批次）
    EXPORTEXPGENBATCH(params) {
        return api.fetch('post', `${delivery}/print/exportExpgenbatch`, params)
    },
    // 完善快递（Excel 导入）
    PERFECTEXPINFO(params) {
        return api.fetch('post', `${delivery}/print/perfectExpinfo`, params)
    },
    // 编辑快递前获取快递详情
    FINDUPDATEEXPINFO(params) {
        return api.fetch('post', `${delivery}/print/findUpdateExpinfo`, params)
    },
    // 获取快递详细信息(含附属表、合并快递信息)
    DELIVERY_FINDEXPINFODETAIL(params) {
        return api.fetch('post', `${delivery}/print/findExpinfoDetail`, params)
    },
    // 获取缓存快递方式
    GET_ALLEXPMODENAMECACHE(params) {
        return api.fetch('post', `${delivery}/print/getAllExpmodeNameCache`, params)
    },
    // 重置待发
    UPDATEEXPINFOROLLBACK(params) {
        return api.fetch('post', `${delivery}/print/updateExpinfoRollback`, params)
    },
    // 合并快递（勾选/一键）
    MERGEEXPRESS(params) {
        return api.fetch('post', `${delivery}/print/mergeExpress`, params)
    },
    // 热敏下单
    SUBORDER(params) {
        return api.fetch('post', `${delivery}/print/subOrder`, params)
    },
    // 单号采集
    UPDATEEXPNOCOLLECT(params) {
        return api.fetch('post', `${delivery}/print/updateExpnoCollect`, params)
    },
    // 增加快递打印批次信息
    ADDEXPPRINTBATCH(params) {
        return api.fetch('post', `${delivery}/print/addExpprintBatch`, params)
    },
    // 联邦热敏打印初始化
    LBPRINTINIT(params) {
        return api.fetch('post', `${delivery}/print/lbprintInit`, params)
    },
    // 韵达热敏打印初始化
    YDPRINTINIT(params) {
        return api.fetch('post', `${delivery}/print/ydprintInit`, params)
    },
    // 完成打印
    FINISHEDPRINT(params) {
        return api.fetch('post', `${delivery}/print/finishedPrint`, params)
    },
    // 非打印单号采集详情
    TOSETEXPNOPAGE(params) {
        return api.fetch('post', `${delivery}/print/toSetExpnoPage`, params)
    },
    // 单号采集详情
    FINDSETEXPNO(params) {
        return api.fetch('post', `${delivery}/print/findSetexpno`, params)
    },
    // 编辑快递包裹数量
    UPDATEPACKAGENUM(params) {
        return api.fetch('post', `${delivery}/print/updatePackagenum`, params)
    },
    // 获取京准取时间列表
    GET_PICKUPINTIMELIST(params) {
        return api.fetch('post', `${delivery}/print/getPickupIntimeList`, params)
    },
    // 快递打印批次记录列表
    GET_EXPPRINTRECORDLIST(params) {
        return api.fetch('post', `${delivery}/expPrintRecord/getExpPrintRecordList`, params)
    },
    // 打印批次详情列表
    GET_EXPPRINTRECORDDETAIL(params) {
        return api.fetch('post', `${delivery}/expPrintRecord/getExpPrintRecordDetail`, params)
    },
    // 全部快递列表
    GET_ALLEXPINFOLIST(params) {
        return api.fetch('post', `${delivery}/allexpinfo/getAllExpinfoList`, params)
    },
    // 全部快递导出（可按检索条件/勾选）
    EXPORTALLEXPINFO(params) {
        return api.fetch('post', `${delivery}/allexpinfo/exportAllExpinfo`, params)
    },
    // MQ导出任务列表
    TASKRECORDLIST(params) {
        return api.fetch('post', `${delivery}/allexpinfo/taskRecordList`, params)
    },
    // 快递补发
    READDEXPINFO(params) {
        return api.fetch('post', `${delivery}/allexpinfo/reAddExpinfo`, params)
    },
    // 是否已申请补发
    GET_APPLYINFO(params) {
        return api.fetch('post', `${delivery}/allexpinfo/getApplyinfo`, params)
    },
    // 获取原有收货地址
    GET_RECEIVERBYEXPCODE(params) {
        return api.fetch('post', `${delivery}/allexpinfo/getReceiverByExpcode`, params)
    },
    // 快递申请补发
    APPLYREISSUE(params) {
        return api.fetch('post', `${delivery}/allexpinfo/applyReissue`, params)
    },
    // 追加快递单号
    APPENDEXPNO(params) {
        return api.fetch('post', `${delivery}/allexpinfo/appendExpno`, params)
    },
    // 编辑快递
    EDITEXPINFO(params) {
        return api.fetch('post', `${delivery}/allexpinfo/editExpinfo`, params)
    },
    // 退货
    REFUNDCONCATEXPINFO(params) {
        return api.fetch('post', `${delivery}/allexpinfo/refundConcatExpinfo`, params)
    },
    // 正常/问题结单
    FINISHORDER(params) {
        return api.fetch('post', `${delivery}/allexpinfo/finishOrder`, params)
    },
    // 导入快递列表
    GET_IMPORTEXPINFOLIST(params) {
        return api.fetch('post', `${delivery}/importExpinfo/getImportExpinfoList`, params)
    },
    // 快递漏单列表
    GET_LEAKEXPINFOLIST(params) {
        return api.fetch('post', `${delivery}/leakExpinfo/getLeakExpinfoList`, params)
    },
    // 待发货发卡订单列表
    GET_LISTPENORDSHIPPED(params) {
        return api.fetch('post', `${delivery}/allexpinfo/getListPenordshipped`, params)
    },
    // 待发货发卡订单详情
    GET_THIRDORDERDETAIL(params) {
        return api.fetch('post', `${delivery}/allexpinfo/getThirdOrderDetail`, params)
    },
    // 勾选打印/检索打印（发卡订单）
    THIRDORDERPRINT(params) {
        return api.fetch('post', `${delivery}/allexpinfo/thirdOrderPrint`, params)
    },
    // 获取ERP发货记录列表
    GET_ERPFINDEXPLIST(params) {
        return api.fetch('post', `${delivery}/erp/getErpFindExpList`, params)
    },
    // ERP立即下单
    SUBGYORDER(params) {
        return api.fetch('post', `${delivery}/erp/subGyOrder`, params)
    },
    //获取针式打印快递类型
    LISTPRICATEINFO() {
        return api.fetch('post', `${delivery}/common/listPricateinfo`);
    },
    //获取默认寄件方
    GET_DEFSENDERINFO(params) {
        return api.fetch('post', `${delivery}/common/getDefSenderinfo`, params);
    },
    //验证登录密码
    CHECKUSERINFO(params) {
        return api.fetch('post', `${delivery}/print/checkUserinfo`, params);
    },
    //获取菜鸟快递方式
    LISTEXPMODEFORCN() {
        return api.fetch('post', `${delivery}/print/listExpmodeForCN`);
    },
    //获取菜鸟寄件地址
    LISTCNADDR(params) {
        return api.fetch('post', `${delivery}/print/listCNAddr`, params);
    },
    //查询菜鸟打印数据
    GET_CNDOCUMENT(params) {
        return api.fetch('post', `${delivery}/print/getCnDocuments`, params);
    },
    //获取顺丰token
    GET_SF_TOKEN() {
        return api.fetch('post', `${delivery}/print/getSFAccessToken`);
    },
    //获取京东面单模板
    GET_JD_TEMPLATELIST(params) {
        return api.fetch('post', `${delivery}/print/getJDTemplateList`, params);
    },
    //获取京东面单打印数据
    GET_JD_PRINTDATA(params) {
        return api.fetch('post', `${delivery}/print/getJDPrintData`, params);
    },
    //模拟京东快递下单
    SUB_JD_ORDER_VIRTUAL(params) {
        return api.fetch('post', `${delivery}/print/subJdOrderOfVirtual`, params);
    },
    // 管理中心接口 -------------------------------------------------------------------------------- 管理中心接口
    // 获取企业信息配置
    GET_CMPYINFO(params) {
        return api.fetch('post', `${base}/cmpyinfo/getCmpyinfo`, params)
    },
    // 修改企业信息配置
    UPDATECMPYINFO(params) {
        return api.fetch('post', `${base}/cmpyinfo/updateCmpyinfo`, params)
    },
    // 校验企业名称是否可用
    CHEKCMPYNAME(params) {
        return api.fetch('post', `${base}/cmpyinfo/chekCmpyName`, params)
    },
    // 获取公共服务配置
    GET_BASEPUBCONFIGINFO(params) {
        return api.fetch('post', `${base}/pubconfig/getPubconfiginfo`, params)
    },
    // 获取公共服务配置
    UPDATEPUBCONFIGINFO(params) {
        return api.fetch('post', `${base}/pubconfig/updatePubconfiginfo`, params)
    },
    // 获取系统控制元素信息
    GET_SYSCONELEMENTSINFO(params) {
        return api.fetch('post', `${base}/sysconelementsinfo/getSysconelementsinfo`, params)
    },
    // 品牌个性配置详细
    GET_BASECARDSYSBASEINFO(params) {
        return api.fetch('post', `${base}/cardsysbaseinfo/getCardsysbaseinfo`, params)
    },
    // 品牌个性化配置
    ADDORUPDATECARDSYSBASEINFO(params) {
        return api.fetch('post', `${base}/cardsysbaseinfo/addOrUpdateCardsysbaseinfo`, params)
    },
    // 获取品牌设置的提货日历模板
    GET_CARDSYSBASEINFOPICKUPLIMITTEMPLATERELS(params) {
        return api.fetch('post', `${base}/cardsysbaseinfo/getCardsysbaseinfoPickuplimittemplaterels`, params)
    },
    // 获取订单发货配置
    GET_PUBORDPRINTINFO(params) {
        return api.fetch('post', `${base}/pubordprint/getPubordprintinfo`, params)
    },
    // 修改订单发货配置
    UPDATEPUBORDPRINTINFO(params) {
        return api.fetch('post', `${base}/pubordprint/updatePubordprintinfo`, params)
    },
    // 获取快递服务配置列表
    GET_SYSEXPPARAINFOLIST(params) {
        return api.fetch('post', `${base}/sysexpparainfo/getSysexpparainfoList`, params)
    },
    // 获取快递服务配置详细
    GET_SYSEXPPARAINFO(params) {
        return api.fetch('post', `${base}/sysexpparainfo/getSysexpparainfo`, params)
    },
    // 配置快递服务参数
    UPDATESYSEXPPARAINFO(params) {
        return api.fetch('post', `${base}/sysexpparainfo/updateSysexpparainfo`, params)
    },
    // 暂停/启用快递服务配置
    UPDATESTATUS(params) {
        return api.fetch('post', `${base}/sysexpparainfo/updateStatus`, params)
    },
    // 寄件方列表
    GET_SENDERINFOLIST(params) {
        return api.fetch('post', `${base}/senderinfo/getSenderinfoList`, params)
    },
    // 获取寄件方详细
    GET_SENDERINFODETAIL(params) {
        return api.fetch('post', `${base}/senderinfo/getSenderinfoDetail`, params)
    },
    // 新增/修改寄件方信息
    SAVESENDERINFO(params) {
        return api.fetch('post', `${base}/senderinfo/saveSenderinfo`, params)
    },
    // 修改寄件方状态
    UPDSENDERINFOSTATUS(params) {
        return api.fetch('post', `${base}/senderinfo/updSenderinfoStatus`, params)
    },
    // 配送区域列表
    GET_REGIONINFOLIST(params) {
        return api.fetch('post', `${base}/region/getRegioninfoList`, params)
    },
    // 获取配送区域详细
    GET_REGIONINFODETAIL(params) {
        return api.fetch('post', `${base}/region/getRegioninfoDetail`, params)
    },
    // 配送区域关联范围信息
    GET_REGIONINFORANGEINFOS(params) {
        return api.fetch('post', `${base}/region/getRegioninfoRangeInfos`, params)
    },
    // 配送区域保存（新增、修改）
    SAVEREGION(params) {
        return api.fetch('post', `${base}/region/saveRegion`, params)
    },
    // 校验配送区域名称是否可用
    CHEKREGIONINFONAME(params) {
        return api.fetch('post', `${base}/region/chekRegioninfoName`, params)
    },
    // 修改配送区域状态
    UPDATEREGIONSTATUS(params) {
        return api.fetch('post', `${base}/region/updateRegionStatus`, params)
    },
    // 获取配送区域设置的商品列表
    GET_REGIONINFOOFGOODS(params) {
        return api.fetch('post', `${base}/region/getRegioninfoOfGoods`, params)
    },
    // 批量设置商品配送区域
    CHOOSEGOODSFORREGIONINFO(params) {
        return api.fetch('post', `${base}/region/chooseGoodsForRegioninfo`, params)
    },
    // 获取临时禁制配送区域详情
    GET_NODELIVERYDISAREAINFO(params) {
        return api.fetch('post', `${base}/region/getNodeliverydisareaInfo`, params)
    },
    // 获取临时禁制配送区域关联区域
    GET_NODELIVERYDISAREAINFORANGE(params) {
        return api.fetch('post', `${base}/region/getNodeliverydisareaInfoRange`, params)
    },
    // 保存/修改临时禁制配送区域信息
    ADDBATCHNODELIVERY(params) {
        return api.fetch('post', `${base}/region/addBatchNodelivery`, params)
    },
    // 运费模板基础信息列表
    GET_POSTERTEMPLATEINFOLIST(params) {
        return api.fetch('post', `${base}/poster/getPostertemplateList`, params)
    },
    // 邮费模板详细
    GET_POSTERTEMPLATEINFODETAIL(params) {
        return api.fetch('post', `${base}/poster/getPostertemplateDetail`, params)
    },
    // 新增/编辑邮费模板
    SAVEPOSTERTEMPLATEINFO(params) {
        return api.fetch('post', `${base}/poster/savePostertemplate`, params)
    },
    // 运费模板设置商品
    HANDLEPOSTERTEMPLATEGOODSDREL(params) {
        return api.fetch('post', `${base}/poster/chooseGoodsForPostertemplate`, params)
    },
    // 运费模板名称重复性校验
    CHECKPOSTERTEMPLATENAME(params) {
        return api.fetch('post', `${base}/poster/checkPostertemplateName`, params)
    },
    // 获取营销服务配置
    GET_BASESYSMARINFO(params) {
        return api.fetch('post', `${base}/sysmarinfo/getSysmarinfo`, params)
    },
    // 修改营销服务配置
    UPDATESYSMARINFO(params) {
        return api.fetch('post', `${base}/sysmarinfo/updateSysmarinfo`, params)
    },
    // 获取销售渠道
    GET_CHANNELLIST(params) {
        return api.fetch('post', `${base}/channel/getChannelList`, params)
    },
    // 获取提货日历模板列表
    GET_PICKUPLIMITTEMPLATELIST(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/getPickuplimittemplateList`, params)
    },
    // 获取提货日历模板详细信息
    GET_PICKUPLIMITTEMPLATEDETAIL(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/getPickuplimittemplateDetail`, params)
    },
    // 新增或修改提货日历模板
    ADDORUPDATEPICKUPLIMITTEMPLATE(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/AddOrUpdatePickuplimittemplate`, params)
    },
    // 获取近60天个性配置
    GET_SIXTYPICKUPLIMITSETING(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/getSixtyPickuplimitSeting`, params)
    },
    // 个性设置某一天的提货限制
    SEDAYPICKUPLIMITSETING(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/seDayPickuplimitSeting`, params)
    },
    // 删除提货日历模板
    DELETEPICKUPLIMITTEMPLATE(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/delete`, params)
    },
    // 修改提货日历状态
    UPDATEPICKUPSTATUS(params) {
        return api.fetch('post', `${base}/pickuplimittemplate/updateStatus`, params)
    },
    // 获取热门城市列表
    GET_HOTLIST(params) {
        return api.fetch('post', `${base}/hotcity/getList`, params)
    },
    // 设置热门城市展示顺序
    SETSORT(params) {
        return api.fetch('post', `${base}/hotcity/setSort`, params)
    },
    // 获取热门城市详细
    GET_HOTDETAIL(params) {
        return api.fetch('post', `${base}/hotcity/getDetail`, params)
    },
    // 新增或修改热门城市信息
    HOTSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/hotcity/saveorupdate`, params)
    },
    // 删除热门城市
    HOTDELETE(params) {
        return api.fetch('post', `${base}/hotcity/delete`, params)
    },
    // 商城轮播图新增或修改
    BANNERSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/bannerinfo/saveorupdate`, params)
    },
    // 商城轮播图详细列表
    GET_BANNERLIST(params) {
        return api.fetch('post', `${base}/bannerinfo/getList`, params)
    },
    // 商城公告列表
    GET_BBSLIST(params) {
        return api.fetch('post', `${base}/bbs/getList`, params)
    },
    // 获取公告详细
    GET_BBSDETAIL(params) {
        return api.fetch('post', `${base}/bbs/getDetail`, params)
    },
    // 新增/编辑 公告
    BBSSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/bbs/saveorupdate`, params)
    },
    // 发布、下线公告
    BBSPUBLISHOROFFLINE(params) {
        return api.fetch('post', `${base}/bbs/publishoroffline`, params)
    },
    // 置顶公告
    BBSTOPBBS(params) {
        return api.fetch('post', `${base}/bbs/topbbs`, params)
    },
    // 精心推荐列表
    GET_RECOMMENDLIST(params) {
        return api.fetch('post', `${base}/recommend/getList`, params)
    },
    // 获取精心推荐详细
    GET_RECOMMENDDETAIL(params) {
        return api.fetch('post', `${base}/recommend/getDetail`, params)
    },
    // 新增或修精心推荐信息
    RECOMMENDSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/recommend/saveorupdate`, params)
    },
    // 删除精心推荐
    RECOMMENDDELETE(params) {
        return api.fetch('post', `${base}/recommend/delete`, params)
    },
    // 获取企业介绍详细
    GET_CMPYDETAIL(params) {
        return api.fetch('post', `${base}/cmpyintroduce/getList`, params)
    },
    // 新增/编辑 企业介绍
    CMPYSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/cmpyintroduce/saveorupdate`, params)
    },
    // 获取企业资质列表
    GET_EQPICLIST(params) {
        return api.fetch('post', `${base}/eqpicinfo/getList`, params)
    },
    // 获取企业资质详细
    GET_EQPICDETAIL(params) {
        return api.fetch('post', `${base}/eqpicinfo/getDetail`, params)
    },
    // 新增或修改企业资质信息
    EQPICSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/eqpicinfo/saveorupdate`, params)
    },
    // 删除企业资质
    EQPICDELETE(params) {
        return api.fetch('post', `${base}/eqpicinfo/delete`, params)
    },
    // 获取新闻资讯列表
    GET_NEWSLIST(params) {
        return api.fetch('post', `${base}/newsinfo/getList`, params)
    },
    // 获取新闻资讯详细
    GET_NEWSDETAIL(params) {
        return api.fetch('post', `${base}/newsinfo/getDetail`, params)
    },
    // 新增或修改新闻资讯信息
    NEWSSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/newsinfo/saveorupdate`, params)
    },
    // 发布、下线 新闻资讯
    NEWSPUBLISHOROFFLINE(params) {
        return api.fetch('post', `${base}/newsinfo/publishoroffline`, params)
    },
    // 获取常见问题列表
    GET_FAGLIST(params) {
        return api.fetch('post', `${base}/faq/getList`, params)
    },
    // 获取常见问题详细
    GET_FAGDETAIL(params) {
        return api.fetch('post', `${base}/faq/getDetail`, params)
    },
    // 新增或修改常见问题
    FAGSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/faq/saveorupdate`, params)
    },
    // 常见问题发布、下线
    FAGPUBLISHOROFFLINE(params) {
        return api.fetch('post', `${base}/faq/publishoroffline`, params)
    },
    // 获取对接仓库列表
    GET_STORAGELIST(params) {
        return api.fetch('post', `${base}/storageinfo/getList`, params)
    },
    // 获取对接仓库详细
    GET_STORAGEDETAIL(params) {
        return api.fetch('post', `${base}/storageinfo/getDetail`, params)
    },
    // 新增或修改对接仓库信息
    STORAGESAVEORUPDATE(params) {
        return api.fetch('post', `${base}/storageinfo/saveorupdate`, params)
    },
    // 仓库名称校验
    CHECKSTONAME(params) {
        return api.fetch('post', `${base}/storageinfo/checkStoname`, params)
    },
    // 启用/禁用对接仓库
    STORAGEPUBLISHOROFFLINE(params) {
        return api.fetch('post', `${base}/storageinfo/publishoroffline`, params)
    },
    // 获取总部用户列表
    GET_BASICUSERS(params) {
        return api.fetch('post', `${base}/user/getBasicUsers`, params)
    },
    // 总部用户的新增/编辑操作
    SAVEBASICUSER(params) {
        return api.fetch('post', `${base}/user/saveBasicUser`, params)
    },
    // 获取总部用户的详情
    BASICUSERDETAIL(params) {
        return api.fetch('post', `${base}/user/basicUserDetail`, params)
    },
    // 更改用户状态
    USERUPDSTATUS(params) {
        return api.fetch('post', `${base}/user/updStatus`, params)
    },
    // 校验用户登录账号唯一性
    CHECKUSERNAME(params) {
        return api.fetch('post', `${base}/user/checkUsername`, params)
    },
    // 获取企业角色列表
    GET_SYSTEMROLES(params) {
        return api.fetch('post', `${base}/user/getSystemRoles`, params)
    },
    // 门店员工绑定子门店
    BINDFLOWINFOS(params) {
        return api.fetch('post', `${base}/flowinfo/bindFlowinfos`, params)
    },
    // 获取可/已绑定的子门店列表
    GETFLOWONFOOFBINDLIST(params) {
        return api.fetch('post', `${base}/flowinfo/getFlowinfoOfBindList`, params)
    },

    // 获取流向列表
    GET_FLOWLIST(params) {
        return api.fetch('post', `${base}/flowinfo/getFlowList`, params)
    },
    // 获取流向详情
    GET_FLOWDETAIL(params) {
        return api.fetch('post', `${base}/flowinfo/getFlowDetail`, params)
    },
    // 新增/修改流向
    SAVEFLOW(params) {
        return api.fetch('post', `${base}/flowinfo/saveFlow`, params)
    },
    // 批量修改流向方的服务状态
    UPDATEFLOWSTATUS(params) {
        return api.fetch('post', `${base}/flowinfo/updateStatus`, params)
    },
    // 校验流向名称的唯一性
    CHECKFLOWNAME(params) {
        return api.fetch('post', `${base}/flowinfo/checkFlowname`, params)
    },
    // 流向登录账号重复性校验接口
    CHECKFLOWUSERNAME(params) {
        return api.fetch('post', `${base}/flowinfo/checkFlowUsername`, params)
    },
    // 获取微门店绑定微信二维码
    GET_SUBQRCODE(params) {
        return api.fetch('post', `${base}/flowinfo/getSubQrcode`, params)
    },
    // 解绑企业微门店绑定的微信
    UNBINDWX(params) {
        return api.fetch('post', `${base}/flowinfo/unbindWx`, params)
    },
    // 查询是否绑定了微信
    CHECKOPENID(params) {
        return api.fetch('post', `${base}/flowinfo/checkOpenid`, params)
    },
    // 获取分销商分销额度变更列表
    GET_DISQUOTALIST(params) {
        return api.fetch('post', `${base}/flowinfo/getDisquotaList`, params)
    },
    // 变更分销额度
    UPDISQUOTA(params) {
        return api.fetch('post', `${base}/flowinfo/updisquota`, params)
    },
    // 获取激活记录列表
    GET_ACTRECORDS(params) {
        return api.fetch('post', `${base}/weistore/getActRecords`, params)
    },
    // 获取核销记录列表
    GET_WRITEOFFRECORDS(params) {
        return api.fetch('post', `${base}/weistore/getWriteoffRecords`, params)
    },
    // 激活记录导出
    GET_ACTRECORDSEXPORTURL(params) {
        return api.fetch('post', `${base}/weistore/getActRecordsExporturl`, params)
    },
    // 核销记录导出
    GET_WRITEOFFRECORDSEXPORTURL(params) {
        return api.fetch('post', `${base}/weistore/getWriteoffRecordsExporturl`, params)
    },
    // 获取素材分类列表
    GET_MATLIST(params) {
        return api.fetch('post', `${base}/matclassify/getMatclassifyList`, params)
    },
    // 获取素材分类详细
    GET_MATDETAIL(params) {
        return api.fetch('post', `${base}/matclassify/getMatclassifyDetail`, params)
    },
    // 新增或修改素材分类
    MATSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/matclassify/saveorupdate`, params)
    },
    // 素材分类名称校验（全平台）
    CHECKCLASSIFYNAME(params) {
        return api.fetch('post', `${base}/user/checkClassifyname`, params)
    },
    // 获取素材列表
    GET_GRELIST(params) {
        return api.fetch('post', `${base}/grecardmaterial/getList`, params)
    },
    // 获取素材列表
    GET_GRELIST(params) {
        return api.fetch('post', `${base}/grecardmaterial/getList`, params)
    },
    // 获取素材详细
    GET_GREDETAIL(params) {
        return api.fetch('post', `${base}/grecardmaterial/getDetail`, params)
    },
    // 新增或修改素材信息
    GRESAVEORUPDATE(params) {
        return api.fetch('post', `${base}/grecardmaterial/saveorupdate`, params)
    },
    // 禁用、启用素材
    GREPUBLISHOROFFLINE(params) {
        return api.fetch('post', `${base}/grecardmaterial/publishoroffline`, params)
    },
    // 素材标题校验（全平台）
    CHECKMTITLE(params) {
        return api.fetch('post', `${base}/grecardmaterial/checkMTitle`, params)
    },
    // 企业个性化提货模板列表获取
    GET_PICKTEMPLATELIST(params) {
        return api.fetch('post', `${base}/cmpyspecialrelinfoofexchange/list`, params)
    },
    // 获取宣传动画列表
    GET_ANISETLIST(params) {
        return api.fetch('post', `${base}/aniset/getList`, params)
    },
    // 获取宣传动画详细
    GET_ANISETDETAIL(params) {
        return api.fetch('post', `${base}/aniset/getDetail`, params)
    },
    // 新增或修改宣传动画
    ANISETSAVEORUPDATE(params) {
        return api.fetch('post', `${base}/aniset/saveorupdate`, params)
    },
    // 宣传动画模板信息列表
    GET_TEMPLATETLIST(params) {
        return api.fetch('post', `${base}/aniset/geTemplatetList`, params)
    },
    // 宣传动画名称重复性校验接口
    CHECKANISETNAME(params) {
        return api.fetch('post', `${base}/aniset/checkAnisetname`, params)
    },
    // 文件上传接口 -------------------------------------------------------------------------------- 文件上传接口
    // 上传图片
    UPLOADPIC() {
        return `${common}/uploadPic`
    },
    // 上传视频
    UPLOADVIDEO() {
        return `${common}/uploadVideo`
    },
    // 上传语音
    UPLOADVOICE() {
        return `${common}/uploadVoice`
    },
    //上传文件
    UPLOADFILE() {
        return `${common}/uploadFile`
    },
    // 会员中心接口 ------------------------------------------------------------------------------------------------------ 会员中心接口
    // 获取会员级别列表
    GET_LEVELLIST(params) {
        return api.fetch('post', `${base}/mlevel/getLevelList`, params)
    },
    // 获取会员级别详细
    GET_LEVELDETAIL(params) {
        return api.fetch('post', `${base}/mlevel/getLevelDetail`, params)
    },
    // 会员级别名称重复校验
    MLEVEL_CHECKNAME(params) {
        return api.fetch('post', `${base}/mlevel/checkName`, params)
    },
    // 会员级别配置
    SAVELEVEL(params) {
        return api.fetch('post', `${base}/mlevel/saveLevel`, params)
    },
    // 会员级别状态变更
    MLEVEL_UPDSTATUS(params) {
        return api.fetch('post', `${base}/mlevel/updStatus`, params)
    },
    // 查询分组信息列表
    GET_GROUPLIST(params) {
        return api.fetch('post', `${base}/group/getGroupList`, params)
    },
    // 保存分组信息
    SAVEGROUP(params) {
        return api.fetch('post', `${base}/group/saveGroup`, params)
    },
    // 查询分组详情
    GET_GROUPDETAIL(params) {
        return api.fetch('post', `${base}/group/getGroupDetail`, params)
    },
    // 同步微信分组
    SYNCWXGROUP(params) {
        return api.fetch('post', `${base}/group/syncWxGroup`, params)
    },
    // 删除微信分组
    DELGROUP(params) {
        return api.fetch('post', `${base}/group/delGroup`, params)
    },
    // 查询指定分组下的会员
    GET_MEMBERSBYGROUP(params) {
        return api.fetch('post', `${base}/group/getMembersByGroup`, params)
    },
    // 将指定会员移出指定分组
    REMGROUP(params) {
        return api.fetch('post', `${base}/group/remGroup`, params)
    },
    // 会员分组名称重复校验
    CHECKGROUPNAME(params) {
        return api.fetch('post', `${base}/group/checkGroupName`, params)
    },
    // 查询注册会员信息列表
    GET_MEMBERLIST(params) {
        return api.fetch('post', `${base}/memberService/getMemberList`, params)
    },
    // 查询注册会员详细
    GET_MEMBERDETAIL(params) {
        return api.fetch('post', `${base}/memberService/getMemberDetail`, params)
    },
    // 查询注册会员关联的券卡列表
    GET_CODEINFOBYMEMBER(params) {
        return api.fetch('post', `${base}/memberService/getCardList`, params)
    },
    // 查询注册会员关联的订单信息
    GET_ORDERINFOBYMEMBER(params) {
        return api.fetch('post', `${base}/memberService/getOrderinfoList`, params)
    },
    // 查询注册会员关联的快递信息
    GET_EXPINFOBYMEMBER(params) {
        return api.fetch('post', `${base}/memberService/getExpinfoList`, params)
    },
    // 保存会员信息
    SAVEMEMBER(params) {
        return api.fetch('post', `${base}/memberService/saveMember`, params)
    },
    // 批量设置分组
    SETGROUP(params) {
        return api.fetch('post', `${base}/memberService/batchGroup`, params)
    },
    // 导出注册会员信息列表
    EXPORTMEMBERLIST(params) {
        return api.fetch('post', `${base}/memberService/exportMemberList`, params)
    },
    // 更改会员状态
    MEMBER_UPDSTATUS(params) {
        return api.fetch('post', `${base}/memberService/updStatus`, params)
    },
    // 获取最近一个月的会员/粉丝新增数量
    GET_ADDCOUNT(params) {
        return api.fetch('post', `${base}/memberService/getAddCount`, params)
    },
    // 移除指定会员/粉丝的所属分组
    REMOVEGROUPS(params) {
        return api.fetch('post', `${base}/memberService/removeGroups`, params)
    },
    // 会员余额/积分操作
    UPDBALANCE(params) {
        return api.fetch('post', `${base}/memberService/updBalance`, params)
    },
    // 查询微信粉丝列表
    GET_FOLLOWERLIST(params) {
        return api.fetch('post', `${base}/follower/getFollowerList`, params)
    },
    // 查询微信素材列表
    GET_WXMEDIALIST(params) {
        return api.fetch('post', `${base}/wxmedia/getWxMediaList`, params)
    },
    //查询微信素材详情
    GET_WXMEDIADETAIL(params) {
        return api.fetch('post', `${base}/wxmedia/getDetail`, params)
    },
    // 添加同步微信素材任务
    SYNCWXMEDIA(params) {
        return api.fetch('post', `${base}/wxmedia/syncWxMedia`, params)
    },
    // 查询消息推送列表
    GET_PUSHMSGLIST(params) {
        return api.fetch('post', `${base}/pushmsg/getPushMsgList`, params)
    },
    // 查询消息推送详情
    GET_PUSHMSGDETAIL(params) {
        return api.fetch('post', `${base}/pushmsg/getPushMsgDetail`, params)
    },
    // 创建推送消息
    MSG_SAVEMSG(params) {
        return api.fetch('post', `${base}/pushmsg/saveMsg`, params)
    },
    // 删除消息推送记录
    MSG_DELETEMSG(params) {
        return api.fetch('post', `${base}/pushmsg/deleteMsg`, params)
    },
    //查询推送目标已选择成员人数
    GET_PUSHNUMBER(params) {
        return api.fetch('post', `${base}/pushmsg/getPredictMemberNum`, params)
    },
    // 查询后台任务列表
    GET_TASKINFOLIST(params) {
        return api.fetch('post', `${base}/taskinfo/getTaskInfoList`, params)
    },
    // 营销中心接口 ------------------------------------------------------------------------------------------------------ 营销中心接口
    // 获取免费营销活动列表
    GET_FREEACTIVITYLIST(params) {
        return api.fetch('post', `${base}/marketing/getFreeActivityList`, params)
    },
    // 获取增值营销活动方案列表
    ACTIVITYGAMELIST(params) {
        return api.fetch('post', `${base}/marketing/activityGameList`, params)
    },
    // 获取增值营销活动方案详细
    ACTIVITYGAMEDETAIL(params) {
        return api.fetch('post', `${base}/marketing/activityGameDetail`, params)
    },
    // 获取活动详细
    GET_ACTIVITYDETAIL(params) {
        return api.fetch('post', `${base}/marketing/getActivityDetail`, params)
    },
    // 新增/编辑营销活动
    SAVEACTIVITY(params) {
        return api.fetch('post', `${base}/marketing/saveActivity`, params)
    },
    // 获取营销活动列表
    GET_CMPYACTIVITYLIST(params) {
        return api.fetch('post', `${base}/marketing/getCmpyActivityList`, params)
    },
    // 获取营销活动分类信息列表
    GET_GAMECLASSIFYLIST(params) {
        return api.fetch('post', `${base}/marketing/getGamesclassifyList`, params)
    },
    // 获取企业营销活动分页列表
    GET_CMPYPAGEACTIVITYLIST(params) {
        return api.fetch('post', `${base}/marketing/getCmpyPageActivityList`, params)
    },
    // 获取企业营销活动情况统计
    GET_ACTIVITYSTATISTICSINFO(params) {
        return api.fetch('post', `${base}/marketing/getActivityStatisticsInfo`, params)
    },
    // 设置营销活动状态
    SETACTIVITYSTATUS(params) {
        return api.fetch('post', `${base}/marketing/setActivityStatus`, params)
    },
    // 使用免费活动
    USEFREEACTIVITY(params) {
        return api.fetch('post', `${base}/marketing/useFreeActivity`, params)
    },
    // 获取活动参与记录列表
    GET_CMPYACTIVITYRECORDS(params) {
        return api.fetch('post', `${base}/marketing/getCmpyActivityRecords`, params)
    },
    // 获取活动参与记录详细信息
    GET_CMPYACTIVITYRECORDDETAIL(params) {
        return api.fetch('post', `${base}/marketing/getCmpyActivityRecordDetail`, params)
    },
    // 企业营销活动参与情况统计
    GET_ACTIVITYRECORDSTATISTICSINFO(params) {
        return api.fetch('post', `${base}/marketing/getActivityRecordStatisticsInfo`, params)
    },
    // 获取当前企业营销礼品分类列表
    GET_TARGETCMPYMARGIFTCLASSIFYLIST(params) {
        return api.fetch('post', `${base}/marGiftClassify/getTargetCmpyMarGiftClassifyList`, params)
    },
    // 获取营销礼品分类详细
    GET_MARGIFTCLASSIFYDETAIL(params) {
        return api.fetch('post', `${base}/marGiftClassify/getMarGiftClassifyDetail`, params)
    },
    // 新增/编辑营销礼品分类
    SAVEMARGIFTCLASSIFY(params) {
        return api.fetch('post', `${base}/marGiftClassify/saveMarGiftClassify`, params)
    },
    // 校验营销礼品分类名称是否可用
    CHECKMARGIFTCLASSIFYNAME(params) {
        return api.fetch('post', `${base}/marGiftClassify/checkClassifyName`, params)
    },
    // 设置营销礼品分类状态
    SETMARGIFTCLASSIFYSTATUS(params) {
        return api.fetch('post', `${base}/marGiftClassify/setMarGiftClassifyStatus`, params)
    },
    // 获取企业营销礼品列表
    GET_TARGETCMPYMARGIFTLIST(params) {
        return api.fetch('post', `${base}/margifts/getTargetCmpyMarGiftList`, params)
    },
    // 获取营销礼品详细
    GET_MARGIFTDETAIL(params) {
        return api.fetch('post', `${base}/margifts/getMarGiftDetail`, params)
    },
    // 营销礼品配图信息
    GET_MARGIFTPICS(params) {
        return api.fetch('post', `${base}/margifts/getMarGiftPics`, params)
    },
    // 营销礼品描述信息
    GET_MARGIFTDES(params) {
        return api.fetch('post', `${base}/margifts/getMarGiftDes`, params)
    },
    // 设置营销礼品状态
    SETMARGIFTSTATUS(params) {
        return api.fetch('post', `${base}/margifts/setMarGiftStatus`, params)
    },
    // 校验营销礼品名称是否可用
    CHECKMARGIFTNAME(params) {
        return api.fetch('post', `${base}/margifts/checkMarGiftName`, params)
    },
    // 新增/编辑营销礼品
    SAVEMARGIFT(params) {
        return api.fetch('post', `${base}/margifts/saveMarGift`, params)
    },
    // 选购礼品（流量话费）列表
    GET_MARGIFTLIST(params) {
        return api.fetch('post', `${base}/margifts/getMarGiftList`, params)
    },
    // 获取企业总部引入的礼品集合关系
    GET_GIFTSRELLIST(params) {
        return api.fetch('post', `${base}/margifts/getGiftsRelList`, params)
    },
    // 获取企业总部引入的礼品关系
    GET_MARGIFTREL(params) {
        return api.fetch('post', `${base}/margifts/getMarGiftrel`, params)
    },
    // 营销礼品入库
    BINDMARGIFT(params) {
        return api.fetch('post', `${base}/margifts/bindMarGift`, params)
    },
    // 设置营销礼品库存
    ADDMARGIFTNUM(params) {
        return api.fetch('post', `${base}/margifts/addMarGiftNum`, params)
    },
    // 获取营销账号信息
    GET_MARACCOUNTINFO(params) {
        return api.fetch('post', `${base}/maraccountinfo/getMaraccountinfo `, params)
    },
    // 营销企业所有【自有+平台】礼品分类
    GET_ALLMARGIGTCLASSIFY(params) {
        return api.fetch('post', `${base}/marGiftClassify/getAllMarGiftClassify `, params)
    },
    // 营销账户充值，金额表单提交
    RECHARGEBALANCE(params) {
        return api.fetch('post', `${base}/maraccountinfo/rechargeBalance `, params)
    },
    // 充值金额在线支付，微信二维码获取
    GET_PAYMENTWXURL(params) {
        return api.fetch('post', `${base}/maraccountinfo/getPaymentWxUrl `, params)
    },
    // 获取营销账户充值记录列表
    GET_RECHARGERECORDLIST(params) {
        return api.fetch('post', `${base}/maraccountinfo/getRechargeRecordList `, params)
    },
    // 获取营销账户充值记录列表
    GET_CONSUMERECORDLIST(params) {
        return api.fetch('post', `${base}/maraccountinfo/getConsumeRecordList `, params)
    },
    // 营销订单详细
    GET_MARORDERINFODETAIL(params) {
        return api.fetch('post', `${base}/marorderinfo/getMarorderinfoDetail `, params)
    },
    // 营销订单付款信息
    GET_MARORDERINFOPAYINFO(params) {
        return api.fetch('post', `${base}/marorderinfo/getMarorderPayInfo `, params)
    },
    // 营销订单收货信息
    GET_MARORDERINFOREVERINFO(params) {
        return api.fetch('post', `${base}/marorderinfo/getMarorderReiverinfo `, params)
    },
    // 获取快递类型+快递名称列表
    GET_MARORDEREXPLIST(params) {
        return api.fetch('post', `${base}/marorderinfo/getExpList`, params)
    },
    // 获取消费记统计
    GET_CONSUMERECORDSTATIC(params) {
        return api.fetch('post', `${base}/maraccountinfo/getConsumeRecordStatic `, params)
    },
    // 获取礼品统计
    GET_MARGIFTSTATIC(params) {
        return api.fetch('post', `${base}/maraccountinfo/getMarGiftStatic `, params)
    },
    // 获取活动统计
    GET_ACTIVITYSTATIC(params) {
        return api.fetch('post', `${base}/maraccountinfo/getActivityStatic `, params)
    },
    // 查看订单营销订单支付状态
    GET_MARORDERINFOPAYSTATUS(params) {
        return api.fetch('post', `${base}/marorderinfo/getMarorderinfoPayStatus`, params)
    },
    // 获取待审核、自己发货、营销中心发货订单列表
    GET_MARORDERINFOLIST(params) {
        return api.fetch('post', `${base}/marorderinfo/getMarorderinfoList `, params)
    },
    // 待处理订单-结算发放
    APPLYFORDELIVERY(params) {
        return api.fetch('post', `${base}/marorderinfo/applyForDelivery `, params)
    },
    // 自己发货订单完善快递信息
    IMPROVEEXPRESSDELIVERYINFORMATION(params) {
        return api.fetch('post', `${base}/marorderinfo/improveExpressDeliveryInformation `, params)
    },
    // 营销工具接口 ------------------------------------------------------------------------------------------------------ 营销工具接口
    // 查询营销优惠券列表
    GET_COUPONLIST(params) {
        return api.fetch('post', `${base}/promotion/getCouponList `, params)
    },
    // 查询营销优惠券详情
    GET_COUPONDETAIL(params) {
        return api.fetch('post', `${base}/promotion/getCouponDetail `, params)
    },
    // 保存营销优惠券
    SAVECOUPON(params) {
        return api.fetch('post', `${base}/promotion/saveCoupon `, params)
    },
    // 更改营销优惠券状态
    PROMOTION_UPDSTATUS(params) {
        return api.fetch('post', `${base}/promotion/updStatus `, params)
    },
    // 查询促销活动列表
    GET_PROMOTIONLIST(params) {
        return api.fetch('post', `${base}/promotion/getPromotionList `, params)
    },
    // 查询促销活动详情
    GET_PROMOTIONDETAIL(params) {
        return api.fetch('post', `${base}/promotion/getPromotionDetail `, params)
    },
    // 查询促销活动规则
    GET_PROMOTIONRULES(params) {
        return api.fetch('post', `${base}/promotion/getPromotionRules `, params)
    },
    // 查询促销活动商品列表
    GET_PROMOTIONGOODS(params) {
        return api.fetch('post', `${base}/promotion/getPromotionGoods `, params)
    },
    // 保存促销活动
    SAVEPROMOTION(params) {
        return api.fetch('post', `${base}/promotion/savePromotion`, params)
    },
    // 更改促销活动状态
    UPDPROMOTIONSTATUS(params) {
        return api.fetch('post', `${base}/promotion/updPromotionStatus`, params)
    },
    // 完善爱心活动结果
    COMPLETEPROMOTION(params) {
        return api.fetch('post', `${base}/promotion/completePromotion`, params)
    },
    // 查询生日/新手礼包
    GET_MARKETINGSET(params) {
        return api.fetch('post', `${base}/promotion/getMarketingset`, params)
    },
    // 设置生日/新手礼包
    SETMARKETING(params) {
        return api.fetch('post', `${base}/promotion/setMarketing`, params)
    },
    // 查询会员折扣商品列表
    MEMBERDISCOUNTLIST(params) {
        return api.fetch('post', `${base}/promotion/memberDiscountList`, params)
    },
    // 添加会员折扣商品
    ADDMEMBERGOODS(params) {
        return api.fetch('post', `${base}/promotion/addMemberGoods`, params)
    },
    // 移除会员折扣商品
    REMOVEMEMBERGOODS(params) {
        return api.fetch('post', `${base}/promotion/removeMemberGoods`, params)
    },
    // 查询会员分享商品列表
    SHAREGOODSLIST(params) {
        return api.fetch('post', `${base}/promotion/shareGoodsList`, params)
    },
    // 添加会员折扣商品
    ADDSHAREGOODS(params) {
        return api.fetch('post', `${base}/promotion/addShareGoods`, params)
    },
    // 移除会员分享商品
    REMOVESHAREGOODS(params) {
        return api.fetch('post', `${base}/promotion/removeShareGoods`, params)
    },
    // 查询爱心活动详情
    GET_ACTIVITYDESC(params) {
        return api.fetch('post', `${base}/promotion/getActivityDesc`, params)
    },
    // 查询爱心活动配图列表
    GET_ACTIVITYPIC(params) {
        return api.fetch('post', `${base}/promotion/getActivityPic`, params)
    },
    //  查询是否可选全部商品
    CANUSEALLGOODS(params) {
        return api.fetch('post', `${base}/promotion/canUseallgoods`, params)
    },
    // 仓分享相关接口 ------------------------------------------------------------------------------------------------------ 仓分享相关接口
    // 查询当前企业加入仓分享信息详情
    GET_JOINSHAREPRO(params) {
        return api.fetch('post', `${share}/joinsharepro/getJoinsharepro`, params)
    },
    // 申请供方权限接口
    OPENSUPPLYPER(params) {
        return api.fetch('post', `${share}/joinsharepro/opensupplyper`, params)
    },
    // 当前企业作为供方的企业之间的合作概况
    ASSUPPLYCOOCMPYSTATICS(params) {
        return api.fetch('post', `${share}/cooperationStatic/asSupplyCooCmpyStatics`, params)
    },
    // 当前企业作为供方的供货商品合作概况
    ASSUPPLYGOODSSTATICS(params) {
        return api.fetch('post', `${share}/cooperationStatic/asSupplyGoodsStatics`, params)
    },
    // 当前企业的供货商品按品类分组统计概况
    ASSUPPLYGOODSGROUPBYPCATESTATICS(params) {
        return api.fetch('post', `${share}/cooperationStatic/asSupplyGoodsGroupByPcateStatics`, params)
    },
    // 当前企业作为代销的企业之间的合作概况
    ASPROXYCOOCMPYSTATICS(params) {
        return api.fetch('post', `${share}/cooperationStatic/asProxyCooCmpyStatics`, params)
    },
    // 当前企业作为代销方的代销商品概况
    ASPROXYGOODSSTATICS(params) {
        return api.fetch('post', `${share}/cooperationStatic/asProxyGoodsStatics`, params)
    },
    // 当前企业的代销商品按品类分组统计概况
    ASPROXYGOODSGROUPBYPCATESTATICS(params) {
        return api.fetch('post', `${share}/cooperationStatic/asProxyGoodsGroupByPcateStatics`, params)
    },
    // 获取供需信息列表
    GET_TRADEINFOLIST(params) {
        return api.fetch('post', `${share}/tradeinfo/getTradeinfoList`, params)
    },
    // 供需信息新增/编辑接口
    ADDORUPDATETRADEINFO(params) {
        return api.fetch('post', `${share}/tradeinfo/addOrUpdateTradeinfo`, params)
    },
    // 获取供需信息详情
    GET_TRADEINFO(params) {
        return api.fetch('post', `${share}/tradeinfo/getTradeinfo`, params)
    },
    // 结束发布接口
    CLOSETRADEINFO(params) {
        return api.fetch('post', `${share}/tradeinfo/closeTradeinfo`, params)
    },
    // 获取合作企业列表
    GET_COOCMPYINFOLIST(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getCoocmpyinfoList`, params)
    }, // 获取指定合作企业的详细信息
    GET_COOCMPYINFO(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getCmpyinfo`, params)
    },
    // 获取指定企业附加信息（介绍，资质）
    GET_CMPYATTACHEDINFO(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getCmpyAttachedInfo`, params)
    },
    // 获取当前企业与指定企业的合作状态信息
    GET_CURRENTCOOPERATIONSTATUS(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getCurrentCooperationStatus`, params)
    },
    // 获取当前企业与指定企业的合作详细信息
    GET_CURRENTCOOPERATIONDETAIL(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getCurrentCooperationDetail`, params)
    },
    // 合作状态变更操作接口
    CHANGECOOPERATIONSTATE(params) {
        return api.fetch('post', `${share}/coocmpyinfo/changeCooperationState`, params)
    },
    // 查询合作企业信息下拉列表数据
    GET_COOCMPYOPTIONLIST(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getCoocmpyOptionList`, params)
    },
    // 获取指定合作企业的交易记录列表
    GET_COOCMPYTRADERECORDLIST(params) {
        return api.fetch('post', `${share}/tradeRecord/getCooCmpyTradeRecordList`, params)
    },
    // 获取当前企业与指定合作企业的交易记录列表
    GET_CURRANDCOOCMPYTRADERECORDLIST(params) {
        return api.fetch('post', `${share}/tradeRecord/getCurrAndCooCmpyTradeRecordList`, params)
    },
    // 指定企业作为供方的交易记录统计接口
    GET_ASSUPPLYTRADERECORDSTATICS(params) {
        return api.fetch('post', `${share}/tradeRecord/getAsSupplyTradeRecordStatics`, params)
    },
    // 获取指定合作企业收到的评价列表
    GET_CMPYMUTEVAINFOLIST(params) {
        return api.fetch('post', `${share}/cmpymutevainfo/getCmpymutevainfoList`, params)
    },
    // 新增评价接口
    ADDCMPYMUTEVAINFO(params) {
        return api.fetch('post', `${share}/cmpymutevainfo/addCmpymutevainfo`, params)
    },
    // 获取评价详情
    GET_CMPYMUTEVAINFO(params) {
        return api.fetch('post', `${share}/cmpymutevainfo/getCmpymutevainfo`, params)
    },
    // 评价反馈操作
    FEEDBACKCMPYMUTEVAINFO(params) {
        return api.fetch('post', `${share}/cmpymutevainfo/feedbackCmpymutevainfo`, params)
    },
    // 评价举报接口
    REPORTCMPYMUTEVAINFO(params) {
        return api.fetch('post', `${share}/cmpymutevainfo/reportCmpymutevainfo`, params)
    },
    // 获取指定合作企业的授信额度变更记录
    GET_LINESCHANGEINFOLIST(params) {
        return api.fetch('post', `${share}/lineschangeinfo/getLineschangeinfoList`, params)
    },
    // 调整合作授信额度
    CHANGECOOPERATIONLINES(params) {
        return api.fetch('post', `${share}/lineschangeinfo/changeCooperationLines`, params)
    },
    // 合作退还款
    LINESBACKORREPAY(params) {
        return api.fetch('post', `${share}/lineschangeinfo/linesBackOrRepay`, params)
    },
    // 开通授信额度操作接口
    OPENLINES(params) {
        return api.fetch('post', `${share}/lineschangeinfo/openOrCloseLines`, params)
    },
    // 当前企业作为供方查询与指定合作代销企业之间的合作商品列表
    ASSUPPLYGETSUPPLYGOODSLISTWITHONEPROXY(params) {
        return api.fetch('post', `${share}/cooperationGoods/asSupplyGetSupplyGoodsListWithOneProxy`, params)
    },
    // 供方为代销方调整某个商品的代销价格接口
    UPDATEGOODSCOCPRICEFORPROXY(params) {
        return api.fetch('post', `${share}/cooperationGoods/updateGoodsCocpriceForProxy`, params)
    },
    // 当前企业作为供方查询我的供货商品列表接口
    ASSUPPLYGETMYSUPPLYGOODSLIST(params) {
        return api.fetch('post', `${share}/cooperationGoods/asSupplyGetMySupplygoodsList`, params)
    },
    // 当前企业作为代销方查询我的代销商品列表接口
    ASPROXYGETPROXYGOODSLIST(params) {
        return api.fetch('post', `${share}/cooperationGoods/asProxyGetProxyGoodsList`, params)
    },
    // 供方查询指定商品的代销企业列表接口
    GET_GOODSPROXYCMPYLIST(params) {
        return api.fetch('post', `${share}/cooperationGoods/getGoodsProxyCmpyList`, params)
    },
    // 查询投诉信息列表
    GET_COMPLAINTINFOLIST(params) {
        return api.fetch('post', `${share}/complaintinfo/getComplaintinfoList`, params)
    },
    // 新增评价接口
    ADDORUPDATECOMPLAINTINFO(params) {
        return api.fetch('post', `${share}/complaintinfo/addOrUpdateComplaintinfo`, params)
    },
    // 查询投诉信息详情
    GET_COMPLAINTINFO(params) {
        return api.fetch('post', `${share}/complaintinfo/getComplaintinfo`, params)
    },
    // 查询推荐商品列表
    GET_RECOMMENDGOODSLIST(params) {
        return api.fetch('post', `${share}/recommendinfo/getRecommendGoodsList`, params)
    },
    // 查询推荐企业列表
    GET_RECOMMENDCMPYLIST(params) {
        return api.fetch('post', `${share}/recommendinfo/getRecommendCmpyList`, params)
    },
    // 查询所有企业的供货商品列表
    GET_SHAREGOODSLIST(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getSharegoodsList`, params)
    },
    // 查询商品信息和规格列表接口
    GET_GOODSDETAIL(params) {
        return api.fetch('post', `${share}/coocmpyinfo/getGoodsDetail`, params)
    },
    // 代销商品操作接口
    ADDPROXYGOODS(params) {
        return api.fetch('post', `${share}/coocmpyinfo/addProxyGoods`, params)
    },
    // 获取供方商家列表
    GET_SUPPLYCMPYLIST(params) {
        return api.fetch('post', `${share}/cooperation/getSupplyCmpyList`, params)
    },

    /**
     * 售后服务
     */
    // 获取退换货申请列表
    GET_RETURNAPPLICATIONLIST(params) {
        return api.fetch('post', `${base}/customerService/getReturnapplicationList`, params)
    },
    // 获取退换货申请详细
    GET_RETURNAPPLICATIONDETAIL(params) {
        return api.fetch('post', `${base}/customerService/getReturnapplicationDetail`, params)
    },
    // 设置退换货申请状态
    SET_RETURNAPPLICATIONSTATUS(params) {
        return api.fetch('post', `${base}/customerService/setReturnapplicationStatus`, params)
    },

    // 获取意见建议列表
    GET_SUGGESTIONSLIST(params) {
        return api.fetch('post', `${base}/customerService/getSuggestionsList`, params)
    },
    // 获取意见建议详细
    GET_SUGGESTIONSDETAIL(params) {
        return api.fetch('post', `${base}/customerService/getSuggestionsDetail`, params)
    },
    // 设置意见建议状态
    SET_SUGGESTIONSSTATUS(params) {
        return api.fetch('post', `${base}/customerService/setSuggestionsStatus`, params)
    },

    // 获取评价列表
    GET_GOODSEVARECORDSLIST(params) {
        return api.fetch('post', `${base}/customerService/getGoodsevarecordsList`, params)
    },
    // 获取评价详细
    GET_GOODSEVARECORDSDETAIL(params) {
        return api.fetch('post', `${base}/customerService/getGoodsevarecordsDetail`, params)
    },
    // 设置评价状态
    SET_GOODSEVARECORDSSTATUS(params) {
        return api.fetch('post', `${base}/customerService/setGoodsevarecordsStatus`, params)
    },

    // 消费者提问列表
    GET_FAQLIST(params) {
        return api.fetch('post', `${base}/customerService/getFaqList`, params)
    },
    // 获取消费者提问详细
    GET_FAQDETAIL(params) {
        return api.fetch('post', `${base}/customerService/getFaqDetail`, params)
    },
    // 设置消费者提问状态
    SET_FAQSTATUS(params) {
        return api.fetch('post', `${base}/customerService/setFaqStatus`, params)
    },


    // 有奖售后列表
    GET_FEEDBACKINFOLIST(params) {
        return api.fetch('post', `${base}/customerService/getFeedbackinfoList`, params)
    },
    // 获取有奖售后详细
    GET_FEEDBACKINFODETAIL(params) {
        return api.fetch('post', `${base}/customerService/getFeedbackinfoDetail`, params)
    },
    // 设置有奖售后状态
    SET_FEEDBACKINFOSTATUS(params) {
        return api.fetch('post', `${base}/customerService/setFeedbackinfoStatus`, params)
    },

    // 获取消费者提现申请列表
    GET_WITHDRAWALRECORDSLIST(params) {
        return api.fetch('post', `${base}/customerService/getWithdrawalrecordsList`, params)
    },
    //  获取消费者提现申请详情
    GET_WITHDRAWALRECORDSDETAIL(params) {
        return api.fetch('post', `${base}/customerService/getWithdrawalrecordsDetail`, params)
    },
    // 消费者提现申请处理操作
    UPDATE_WITHDRAWALRECORDSSTATUS(params) {
        return api.fetch('post', `${base}/customerService/updateWithdrawalrecordsStatus`, params)
    },


    // 获取快递补发申请列表
    GET_RESENDAPPLICATIONLIST(params) {
        return api.fetch('post', `${base}/customerService/getResendapplicationList`, params)
    },
    // 获取快递补发申请详情
    GET_RESENDAPPLICATIONDETAIL(params) {
        return api.fetch('post', `${base}/customerService/getResendapplicationDetail`, params)
    },
    // 快递补发申请审核操作
    UPDATE_RESENDAPPLICATIONSTATUS(params) {
        return api.fetch('post', `${base}/customerService/updateResendapplicationStatus`, params)
    },

    // 数据统计接口 ------------------------------------------------------------------------------------------------------ 数据统计接口
    //  获取全部券卡/总部直发券卡统计列表信息
    GET_CARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getCardstatisticsList`, params)
    },
    // 获取全部券卡/总部直发券卡统计列表信息下载地址
    GET_URLFORCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForCardstatisticsList`, params)
    },
    // 获取流向门店券卡统计列表信息
    GET_FLOWCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getFlowCardstatisticsList`, params)
    },
    // 获取流向门店券卡统计列表信息下载地址
    GET_URLFORFLOWCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForFlowCardstatisticsList`, params)
    },
    // 获取流向会员券卡统计列表信息
    GET_MEMBERCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getMemberCardstatisticsList`, params)
    },
    // 获取流向会员券卡统计列表信息下载地址
    GET_URLFORMEMBERCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForMemberCardstatisticsList`, params)
    },
    // 获取兑换礼券统计详细列表信息
    GET_CARDSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getCardstatisticsDetail`, params)
    },
    // 获取兑换礼券统计详细列表信息下载地址
    GET_URLFORCARDSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForCardstatisticsDetail`, params)
    },
    // 获取兑换礼券归类统计列表信息
    GET_CARDCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getCardClassifychoice`, params)
    },
    // 获取兑换礼券归类统计列表信息下载地址
    GET_URLFORCARDCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForCardClassifychoice`, params)
    },
    // 获取全部消费卡统计列表信息
    GET_PRECARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/precardstatistics/getPrecardstatisticsList`, params)
    },
    // 获取全部消费卡统计列表信息下载地址
    GET_URLFORPRECARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/precardstatistics/getUrlForPrecardstatisticsList`, params)
    },
    // 获取全部消费卡统计详细列表信息
    GET_PRECARDSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/precardstatistics/getPrecardstatisticsDetail`, params)
    },
    // 获取全部消费卡统计详细列表信息下载地址
    GET_URLFORPRECARDSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/precardstatistics/getUrlForPrecardstatisticsDetail`, params)
    },
    // 获取全部消费卡归类统计列表信息
    GET_PRECARDCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/precardstatistics/getPrecardClassifychoice`, params)
    },
    // 获取全部消费卡归类统计列表信息下载地址
    GET_URLFORPRECARDCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/precardstatistics/getUrlForPrecardClassifychoice`, params)
    },
    // 获取全部优惠券统计列表信息
    GET_COUPONSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/couponstatistics/getCouponstatisticsList`, params)
    },
    // 获取全部优惠券统计列表信息下载地址
    GET_URLFORCOUPONSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/couponstatistics/getUrlForCouponstatisticsList`, params)
    },
    // 获取全部优惠券统计详细列表信息
    GET_COUPONSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/couponstatistics/getCouponstatisticsDetail`, params)
    },
    // 获取全部优惠券统计详细列表信息下载地址
    GET_URLFORCOUPONSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/couponstatistics/getUrlForCouponstatisticsDetail`, params)
    },
    // 获取全部优惠券归类统计列表信息
    GET_COUPONCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/couponstatistics/getCouponClassifychoice`, params)
    },
    // 获取全部优惠券归类统计列表信息下载地址
    GET_URLFORCOUPONCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/couponstatistics/getUrlForCouponClassifychoice`, params)
    },
    // 获取全部订单统计列表信息
    GET_ORDERSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getOrderstatisticsList`, params)
    },
    // 获取全部订单统计列表信息下载地址
    GET_URLFORORDERSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getUrlForOrderstatisticsList`, params)
    },
    // 获取客服订单统计列表信息
    GET_SERVICESTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getServicestatisticsList`, params)
    },
    // 获取客服订单统计列表信息下载地址
    GET_URLFORSERVICESTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getUrlForServicestatisticsList`, params)
    },
    // 获取派单订单统计列表信息
    GET_APPOINTSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getAppointstatisticsList`, params)
    },
    // 获取派单订单统计列表信息下载地址
    GET_URLFORAPPOINTSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getUrlForAppointstatisticsList`, params)
    },
    // 获取订单统计详细列表信息
    GET_ORDERSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getOrderstatisticsDetail`, params)
    },
    // 获取订单统计详细列表信息下载地址
    GET_URLFORORDERSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getUrlForOrderstatisticsDetail`, params)
    },
    // 获取订单归类统计列表信息
    GET_ORDERCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getOrderClassifychoice`, params)
    },
    // 获取订单归类统计列表信息下载地址
    GET_URLFORORDERCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/orderstatistics/getUrlForOrderClassifychoice`, params)
    },
    // 获取全部/总部快递统计列表信息
    GET_EXPSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getExpstatisticsList`, params)
    },
    // 获取全部/总部快递统计列表信息下载地址
    GET_URLFOREXPSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForExpstatisticsList`, params)
    },
    // 获取门店/发货网点快递统计列表信息
    GET_AGENCYDELIVERYLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getAgencyDeliveryList`, params)
    },
    // 获取门店/发货网点快递统计列表信息下载地址
    GET_URLFORAGENCYDELIVERYLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForAgencyDeliveryList`, params)
    },
    // 获取发货统计详细列表信息
    GET_EXPSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getExpstatisticsDetail`, params)
    },
    // 获取发货统计详细列表信息下载地址
    GET_URLFOREXPSTATISTICSDETAIL(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForExpstatisticsDetail`, params)
    },
    // 获取发货统计归类统计列表信息
    GET_EXPCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getExpClassifychoice`, params)
    },
    // 获取发货统计归类统计列表信息下载地址
    GET_URLFOREXPCLASSIFYCHOICE(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForExpClassifychoice`, params)
    },
    // 获取快递发货统计列表信息
    GET_EXPDELIVERYLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getExpDeliveryList`, params)
    },
    // 获取快递发货统计列表信息下载地址
    GET_URLFOREXPDELIVERYLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForExpDeliveryList`, params)
    },
    // 获取门店-快递发货统计列表信息(实际提货商品列表)
    GET_EXPACTGOODSLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getExpActGoodsList`, params)
    },
    // 获取门店-快递发货统计列表信息下载地址(实际提货商品列表)
    GET_URLFOREXPACTGOODSLIST(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForExpActGoodsList`, params)
    },
    // 获取门店-快递订单明细列表信息
    GET_EXPDELIVERYDETAIL(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getExpDeliveryDetail`, params)
    },
    // 获取门店-快递订单明细列表信息下载地址
    GET_URLFOREXPDELIVERYDETAIL(params) {
        return api.fetch('post', `${statistics}/store/expstatistics/getUrlForExpDeliveryDetail`, params)
    },
    // 获取下载任务列表
    GET_TASKRECORDLIST(params) {
        return api.fetch('post', `${statistics}/taskRecord/taskRecordList`, params)
    },
    // 获取券卡类型列表(用于详细列表条件)
    GET_CARDKINDLIST(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getCardkindList`, params)
    },
    // 获取总部/门店券卡流向列表(用于详细列表条件)
    GET_LISTFLOWINFO(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getListFlowinfo`, params)
    },
    // 获取订单归属方信息列表(用于详细列表条件)
    GET_LISTHANDLERCODE(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getListHandlercode`, params)
    },
    // 获取下单客服信息列表(用于详细列表条件)
    GET_LISTORDERUNAME(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getListOrderuname`, params)
    },
    // 获取派单人信息列表(用于详细列表条件)
    GET_LISTAPPOINTPEOPLE(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getListAppointPeople`, params)
    },
    // 获取实际提货商品下拉列表
    GET_ACTGOODSLIST(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getActGoodsList`, params)
    },
    // 2020/08/19 -------------------------------------------------------------------------------------------- 2020/08/19
    // 获取门店对账收付款列表信息
    GET_ACCOUNTSLIST(params) {
        return api.fetch('post', `${statistics}/cardstatistics/getAccountsList`, params)
    },
    // 获取门店对账收付款列表信息下载地址
    GET_URLFORACCOUNTSLIST(params) {
        return api.fetch('post', `${statistics}/cardstatistics/getUrlForAccountsList`, params)
    },
    // 获取门店对账报表详细列表信息
    GET_ACCOUNTSDETAIL(params) {
        return api.fetch('post', `${statistics}/cardstatistics/getAccountsDetail`, params)
    },
    // 获取门店对账报表详细列表信息下载地址
    GET_URLFORACCOUNTSDETAIL(params) {
        return api.fetch('post', `${statistics}/cardstatistics/getUrlForAccountsDetail`, params)
    },
    // 获取门店对账报表券卡详细列表
    GET_ACCOUNTSCARDDETAIL(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getAccountsCardDetail`, params)
    },
    // 获取门店对账报表券卡详细列表下载地址
    GET_URLFORACCOUNTSCARDDETAIL(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForAccountsCardDetail`, params)
    },
    //软文
    GET_DOCUMENTINFOLIST(params) {
        return api.fetch('post', `${base}/documentinfo/getDocumentinfoList`, params)
    },
    GET_DOCUMENTINFODETAIL(params) {
        return api.fetch('post', `${base}/documentinfo/getDocumentinfoDetail`, params)
    },
    //公告
    COMPANYHEAD(params) {
        return api.fetch('post', `${base}/announcement/getAnnouncementList/store`, params)
    },
    GET_ANNOUNCEMENTDETAIL(params) {
        return api.fetch('post', `${base}/announcement/getAnnouncementDetail`, params)
    },

    /**
     * 金世尊
     */
    // 单品管理 ---------------- 单品管理
    // 获取单品列表
    GET_SINGLEITEMLIST1(params) {
        return api.fetch('post', `${customize}/singleitem/getSingleitemList`, params)
    },
    // 根据单品编号获取单品详情基础信息
    GET_SINGLEITEMDETAIL(params) {
        return api.fetch('post', `${customize}/singleitem/getSingleitemDetail`, params)
    },
    // 查询指定单品对应的总部和门店总库存/已消耗库存列表
    GET_SINGLEITEMINVINFOLIST(params) {
        return api.fetch('post', `${customize}/singleitem/getSingleitemInvinfoList`, params)
    },
    // 库存调拨新增
    SAVETRANSFER(params) {
        return api.fetch('post', `${customize}/transfer/saveTransfer`, params)
    },
    // 查询库存调拨记录列表
    GET_TRANSFERLIST(params) {
        return api.fetch('post', `${customize}/transfer/getTransferList`, params)
    },
    // 库存调拨记录详情
    GET_TRANSFERDETAIL(params) {
        return api.fetch('post', `${customize}/transfer/getTransferDetail`, params)
    },
    // 获取商品规格已经绑定的单品列表
    GET_BINDSINGLEITEMLIST(params) {
        return api.fetch('post', `${goods}/goods/getBindSingleitemList`, params)
    },
    // 销售单管理 --------------------------------------------------------------- 销售单管理
    // 销售单下单商品选择（用于后台缓存下单商品）
    CHOOSESALEGOODS(params) {
        return api.fetch('post', `${customize}/saleorder/chooseSaleGoods`, params)
    },
    // 销售单下单商品获取（用于前端页面同步后台缓存数据）
    GET_SALEGOODS(params) {
        return api.fetch('post', `${customize}/saleorder/getSaleGoods`, params)
    },
    // 销售单下单商品清除（用于前端页面用户取消下单时）
    CLEANSALEGOODS(params) {
        return api.fetch('post', `${customize}/saleorder/cleanSaleGoods`, params)
    },
    // 销售单下单提交（预下单/整单下单）
    SAVESALEORDER(params) {
        return api.fetch('post', `${customize}/saleorder/saveSaleorder`, params)
    },
    // 获取常规订单的绑卡信息
    GET_CARDINFOSBYORDERNO(params) {
        return api.fetch('post', `${customize}/saleorder/getCardInfosByOrderno`, params)
    },
    // 常规单绑卡页面初始化（绑定的券卡后台验证并缓存，会话唯一。）
    INITBINDDATA(params) {
        return api.fetch('post', `${customize}/saleorder/initBindData`, params)
    },
    // 常规单绑卡时礼品券可用验证
    CHECKCARDCODE(params) {
        return api.fetch('post', `${customize}/saleorder/checkCardCode`, params)
    },
    // 常规单绑卡已验证礼品券移除
    REMOVECARDCODE(params) {
        return api.fetch('post', `${customize}/saleorder/removeCardCode`, params)
    },
    // 常规单绑卡表单提交
    BINDCARDCODE(params) {
        return api.fetch('post', `${customize}/saleorder/bindCardCode`, params)
    },
    // 获取销售单列表
    GET_SALEORDERLIST(params) {
        return api.fetch('post', `${customize}/saleorder/getSaleOrderList`, params)
    },
    // 获取销售单基础详情
    GET_SALEORDERDETAIL(params) {
        return api.fetch('post', `${customize}/saleorder/getSaleOrderDetail`, params)
    },
    // 获取销售单支付详情
    GET_SALEORDERPAYDETAIL(params) {
        return api.fetch('post', `${customize}/saleorder/getSaleOrderPayDetail`, params)
    },
    // 获取销售单商品清单
    GET_GOODSINFOOFSALEORDER(params) {
        return api.fetch('post', `${customize}/saleorder/getGoodsInfoOfSaleOrder`, params)
    },
    // 获取常规单列表
    GET_ORDERLISTBYSALE(params) {
        return api.fetch('post', `${customize}/saleorder/getOrderList`, params)
    },
    // 常规单商品清单
    GET_GOODSINFOOFORDERNO(params) {
        return api.fetch('post', `${customize}/saleorder/getGoodsInfoOfOrderno`, params)
    },
    // 获取销售单预下单收货人信息
    GET_RECEIVEROFRESERVE(params) {
        return api.fetch('post', `${customize}/saleorder/getReceiverOfReserve`, params)
    },
    // 获取指定会员商城收货地址/历史收货地址（最大获取最近6条）
    GET_RECEIVEROFMEMBER(params) {
        return api.fetch('post', `${customize}/saleorder/getReceiverOfMember`, params)
    },
    // 销售单申请发货
    APPLYSHIP(params) {
        return api.fetch('post', `${customize}/saleorder/applyShip`, params)
    },
    // 常规单商品数量
    GET_SINGLENUM(params) {
        return api.fetch('post', `${customize}/saleorder/getSingleNum`, params)
    },
    // 销售单申请退款
    APPLYREFUND(params) {
        return api.fetch('post', `${customize}/paybackapply/applyRefund`, params)
    },
    // 销售单订单支付
    PAYSALEORDER(params) {
        return api.fetch('post', `${customize}/saleorder/paySaleOrder`, params)
    },
    // 销售单取消（只有未付款状态的销售单可以取消）
    CANCELSALEORDER(params) {
        return api.fetch('post', `${customize}/saleorder/cancelSaleOrder`, params)
    },
    // 获取退款申请列表
    GET_APPLYREFUNDLIST(params) {
        return api.fetch('post', `${customize}/paybackapply/getApplyRefundList`, params)
    },
    // 销售单退款申请详情
    GET_APPLYREFUNDDETAIL(params) {
        return api.fetch('post', `${customize}/paybackapply/getApplyRefundDetail`, params)
    },
    // 销售单退款申请审核
    AUDITAPPLYOFREFUND(params) {
        return api.fetch('post', `${customize}/paybackapply/auditApplyOfRefund`, params)
    },
    // 销售单退款申请取消
    CANCELAPPLYOFREFUND(params) {
        return api.fetch('post', `${customize}/paybackapply/cancelApplyOfRefund`, params)
    },
    // 销售单退款申请商品详情
    APPLYREFUNDGOODSDETAIL(params) {
        return api.fetch('post', `${customize}/paybackapply/applyRefundGoodsDetail`, params)
    },
    // OMS批量导入销售单
    IMPORTSALEOEDERS(params) {
        return api.fetch('post', `${customize}/importSaleOrder/importSaleOrders`, params)
    },
    // OMS批量导入销售单获取数量
    TVJPVYPPDPCCWJHW(params) {
        return api.fetch('post', `${customize}/importSaleOrder/estimateData`, params)
    },
    // 确认退款操作
    PAYBACKOPER(params) {
        return api.fetch('post', `${customize}/paybackapply/paybackOper`, params)
    },
    //金世尊门店接口启用以前的接口
    //金世尊额度管理接口
    //开通额度
    OPENDISQUOTA(params) {
        return api.fetch('post', `${base}/flowinfo/openDisquota`, params)
    },
    //额度详情
    GET_STOREDISQUOTA(params) {
        return api.fetch('post', `${base}/flowinfo/getStoredisquota`, params)
    },
    //额度变更
    UPDATESTOREDISQUOTA(params) {
        return api.fetch('post', `${base}/flowinfo/updateStoredisquota`, params)
    },
    //额度变更记录列表
    GET_STROEDISQUOTACHANGELIST(params) {
        return api.fetch('post', `${base}/flowinfo/getStoredisquotachangeList`, params)
    },
    //门店额度汇总详情（只统计分销商的）getStoredisquotaTotal
    GET_STOREDISQUOTATOTAL(params) {
        return api.fetch('post', `${base}/flowinfo/getStoredisquotaTotal`, params)
    },
    // 门店相关 ---------------------------------------------------------- 门店相关
    // 获取流向列表
    GET_FLOWLISTBYSALE(params) {
        return api.fetch('post', `${customize}/flowinfo/getFlowList`, params)
    },
    // 获取流向列表
    GET_FLOWDETAILBYSALE(params) {
        return api.fetch('post', `${customize}/flowinfo/getFlowDetail`, params)
    },
    // 购买/销售方管理 ----------------------------------------------------------------------- 购买/销售方管理
    // 购买方/销售方列表
    GET_INVOICETITLELIST(params) {
        return api.fetch('post', `${customize}/invoicetitle/getInvoicetitleList`, params)
    },
    // 购买方/销售方详情
    GET_INVOICETITLEDETAIL(params) {
        return api.fetch('post', `${customize}/invoicetitle/getInvoicetitleDetail`, params)
    },
    // 购买方/销售方名称唯一性校验（新增/编辑时）
    INVOICE_CHECKNAME(params) {
        return api.fetch('post', `${customize}/invoicetitle/checkName`, params)
    },
    // 购买方/销售方状态变更（批量）
    INVOICE_UPDATESTATUS(params) {
        return api.fetch('post', `${customize}/invoicetitle/updateStatus`, params)
    },
    // 购买方/销售方新增/编辑
    SAVEINVOICETITLE(params) {
        return api.fetch('post', `${customize}/invoicetitle/saveInvoicetitle`, params)
    },
    // 开票商品采购管理 ---------------------------------------------------------------- 开票商品采购管理
    // 开票商品采购列表
    GET_INVGOODSPURINFOLIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getInvgoodspurinfoList`, params)
    },
    // 开票商品采购基础详情
    GET_INVGOODSPURINFODETAIL(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getInvgoodspurinfoDetail`, params)
    },
    // 开票商品采购明细列表
    GET_INVGOODSPURDETAILLIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getInvgoodspurdetailList`, params)
    },
    // 开票采购提交
    SAVEINVGOODSPURINFO(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/saveInvgoodspurinfo`, params)
    },
    // 开票采购审核
    REVIEWINVGOODSPURINFO(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/reviewInvgoodspurinfo`, params)
    },
    // 查询开票商品列表
    GET_INVGOODSINFOLIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getInvgoodsinfoList`, params)
    },
    // 开票商品详情
    GET_INVGOODSINFODETAIL(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getInvgoodsinfoDetail`, params)
    },
    // 开票采购审核
    UPDATEINVGOODSPURINFOPRICE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/updateInvgoodspurinfoPrice`, params)
    },
    // 获取指定销售方最大开票金额
    GET_MAXPRICE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getMaxprice`, params)
    },
    // 获取指定销售方最大开票金额
    UPDATEINVGOODSINFOPRICE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/updateInvgoodsinfoPrice`, params)
    },
    // 获取指定销售方最大开票金额
    Inv_BATCHUPDSTATUS(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/batchUpdStatus`, params)
    },
    // 查询开票商品单位列表（去重）
    GET_UNITLIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getUnitList`, params)
    },
    // 开票管理 ------------------------------------------------------------------------------------------- 开票管理
    // 开票申请列表
    GET_INVOICERECORDLIST(params) {
        return api.fetch('post', `${customize}/invoicerecord/getInvoicerecordList`, params)
    },
    // 获取可开票会员信息列表
    GET_INVOICEMEMBERLIST(params) {
        return api.fetch('post', `${customize}/invoicerecord/getMemberList`, params)
    },
    // 开票商品明细后台缓存初始化
    INITGOODSCACHE(params) {
        return api.fetch('post', `${customize}/invoicerecord/initGoodsCache`, params)
    },
    // 开票商品明细后台缓存提交（不传参数时直接返回现有缓存数据）
    SAVEGOODSCACHE(params) {
        return api.fetch('post', `${customize}/invoicerecord/saveGoodsCache`, params)
    },
    // 开票商品明细后台缓存删除
    REMOVEGOODSCACHE(params) {
        return api.fetch('post', `${customize}/invoicerecord/removeGoodsCache`, params)
    },
    // 开票商品明细后台缓存获取
    GET_GOODSCACHE(params) {
        return api.fetch('post', `${customize}/invoicerecord/getGoodsCache`, params)
    },
    // 申请开票提交
    SUBINVOICERECORD(params) {
        return api.fetch('post', `${customize}/invoicerecord/subInvoiceRecord`, params)
    },
    // 开票申请基础详情
    GET_INVOICERECORDDETAIL(params) {
        return api.fetch('post', `${customize}/invoicerecord/getInvoiceRecordDetail`, params)
    },
    // 开票申请商品/打包商品明细
    GET_INVOICEGOODSDETAIL(params) {
        return api.fetch('post', `${customize}/invoicerecord/getInvoiceGoodsDetail`, params)
    },
    // 开票申请审核提交
    AUDITINVOICERECORD(params) {
        return api.fetch('post', `${customize}/invoicerecord/auditInvoiceRecord`, params)
    },
    // 录入发票单号提交
    INPUTINVOICENO(params) {
        return api.fetch('post', `${customize}/invoicerecord/inputInvoiceno`, params)
    },
    // 录入发票单号提交
    CANCELRECORD(params) {
        return api.fetch('post', `${customize}/invoicerecord/cancelRecord`, params)
    },
    // 2020/08/20 ------------------------------------------------------------ 2020/08/20 门店/发货网点/分销商密码修改
    UPDATEPASSWORD(params) {
        return api.fetch('post', `${base}/flowinfo/updatePassWord`, params)
    },

    GET_URLFORSALEORDERLIST(params) {
        return api.fetch('post', `${customize}/saleorder/getUrlForSaleOrderList`, params)
    },
    // 2020/08/24 ------------------------------------------------------------ 2020/08/24 金世尊需求
    // 序列号段验证
    CHECKSERIALS(params) {
        return api.fetch('post', `${customize}/saleorder/checkSerials`, params)
    },
    // 查询指定商品序列号段缓存
    GET_KINDCODESERIALS(params) {
        return api.fetch('post', `${customize}/saleorder/getKindcodeSerials`, params)
    },
    // 查询指定商品编码缓存
    GET_CODESBYKINDCODE(params) {
        return api.fetch('post', `${customize}/saleorder/getCodesByKindcode`, params)
    },
    // 序列号段绑卡汇总清单
    GET_GOODSINFOOFORDERNOWITHCARDCACHE(params) {
        return api.fetch('post', `${customize}/saleorder/getGoodsInfoOfOrdernoWithCardCache`, params)
    },
    // 查询商品SKU列表
    GET_GOODSSKULIST(params) {
        return api.fetch('post', `${goods}/goods/getGoodsSkuList`, params)
    },
    // 导出商品SKU列表
    EXPORTGOODSSKULIST(params) {
        return api.fetch('post', `${goods}/goods/exportGoodsSkuList`, params)
    },
    // 销售单导入发货文件上传
    IMPORTSHIPUPLOAD(params) {
        return api.fetch('post', `${customize}/saleorder/importShipUpload`, params)
    },
    // 销售单导入发货批次信息列表
    GET_SALEORDIMPORTBATCHLIST(params) {
        return api.fetch('post', `${customize}/saleorderImportbatch/getSaleordimportbatchList`, params)
    },
    // 销售单导入发货记录列表
    GET_SALEORDIMPORTBATCHDETAILLIST(params) {
        return api.fetch('post', `${customize}/saleorderImportbatch/getSaleordimportbatchdetailList`, params)
    },
    // 销售单导入发货记录详细
    GET_SALEORDIMPORTBATCHDETAIL(params) {
        return api.fetch('post', `${customize}/saleorderImportbatch/getSaleordimportbatchdetail`, params)
    },
    // 销售单导入发货记录修改
    UPDATESALEORDIMPORTBATCHDETAIL(params) {
        return api.fetch('post', `${customize}/saleorderImportbatch/updateSaleordimportbatchdetail`, params)
    },
    // 销售单导入发货记录删除
    DELETESALEORDIMPORTBATCHDETAIL(params) {
        return api.fetch('post', `${customize}/saleorderImportbatch/deleteSaleordimportbatchdetail`, params)
    },
    // 销售单导入发货记录发货
    SENDSALEORDIMPORT(params) {
        return api.fetch('post', `${customize}/saleorder/sendSaleordimport`, params)
    },
    // 2020/08/27 ------------------------------------------------------------ 2020/08/27 金世尊需求
    // 券卡分销回收
    RECYCLECARD(params) {
        return api.fetch('post', `${customize}/saleorder/recycleCard`, params)
    },
    // 获取销售单券卡列表
    GET_SALEORDERCARDLIST(params) {
        return api.fetch('post', `${customize}/saleorder/getSaleOrderCardList`, params)
    },
    // 2020/09/01 ------------------------------------------------------------ 2020/09/01 金世尊需求
    // 渠道列表
    GET_SALECHANNELLIST(params) {
        return api.fetch('post', `${base}/salechannel/getSalechannelList`, params)
    },
    /**
     * 收付款管理
     */
    //收付款账号列表
    GETACCOUNTINFOLIST(params) {
        return api.fetch('post', `${customize}/account/getAccountinfoList`, params)
    },
    //收付款账号名称唯一性校验
    CHECKNAME(params) {
        return api.fetch('post', `${customize}/account/checkName`, params)
    },
    //收付款账号状态变更（批量）
    UODATESTATUS(params) {
        return api.fetch('post', `${customize}/account/updateStatus`, params)
    },
    //收付款账号保存
    SABEACCOUNTINFO(params) {
        return api.fetch('post', `${customize}/account/saveAccountinfo`, params)
    },
    //消费者收付款明细记录列表
    CONSUMERPAYINFOLIST(params) {
        return api.fetch('post', `${customize}/account/consumerPayInfoList`, params)
    },
    //导出收付款记录列表
    EXPORTCONSUMERPAYINFOLIST(params) {
        return api.fetch('post', `${customize}/account/exportConsumerPayInfoList`, params)
    },
    //收付款操作
    SAVEPAYINFO(params) {
        return api.fetch('post', `${customize}/account/savePayInfo`, params)
    },
    //批量收款
    BATCHSAVEPAYINFO(params) {
        return api.fetch('post', `${customize}/account/batchSavePayInfo`, params)
    },
    // 2020/09/01 ------------------------------------------------------------ 2020/09/01 金世尊需求
    // 单品库存调拨审核
    AUDITTRANSFER(params) {
        return api.fetch('post', `${customize}/transfer/auditTransfer`, params)
    },
    // 单品库存调拨编辑
    EDITTRANSFER(params) {
        return api.fetch('post', `${customize}/transfer/editTransfer`, params)
    },
    // 2020/09/02 ---------------------------------------------------------------- 2020/09/02 金世尊流向接口
    // 获取流向列表
    GET_FLOWLISTFORTRANSFER(params) {
        return api.fetch('post', `${base}/flowinfo/getFlowListForTransfer`, params)
    },
    // 校验是否存在实际未发货的常规单
    GET_NOSENDEDORDERINFO(params) {
        return api.fetch('post', `${customize}/saleordercheck/getnosendedorderinfo`, params)
    },
    // 2020/10/16 --------------------------------------------------------------------------- 2020/10/16
    // 获取实际提货商品下拉列表
    GET_CHANNELNAMELIST(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getChannelnameList`, params)
    },
    //  获取门店/总部退款审核列表信息下载地址
    GET_URLFORAPPLYRDFUNDLIST(params) {
        return api.fetch('post', `${customize}/paybackapply/getUrlForApplyRefundList`, params)
    },
    // 2020/11/06 --------------------------------------------------------------------------- 2020/11/06
    // 导出开票商品采购列表
    EXPORTINVGOODSPURINFOLIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/exportInvgoodspurinfoList`, params)
    },
    // 作废开票申请（只能财务作废审核通过的开票申请）
    INVALIDRECORD(params) {
        return api.fetch('post', `${customize}/invoicerecord/invalidRecord`, params)
    },
    // 导出开票申请列表
    EXPORTINVOICERECORDLIST(params) {
        return api.fetch('post', `${customize}/invoicerecord/exportInvoicerecordList`, params)
    },
    // 2020/11/13 --------------------------------------------------------------------------- 2020/11/13
    // 查询开票商品采购供应商列表（去重）
    GET_SUPPLYERNAMELIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getSupplyernameList`, params)
    },
    // 导出开票商品列表
    EXPORTINVGOODSINFOLIST(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/exportInvgoodsinfoList`, params)
    },
    // 获取订单基础信息列表数据
    GET_ORDERBASEINFOJSZLIST(params) {
        return api.fetch('post', `${order}/store/order/getOrderBaseInfoJSZList`, params)
    },
    // 修改销售单金额
    UPDSALEORDERAMOUNT(params) {
        return api.fetch('post', `${customize}/saleorder/updSaleOrderAmount`, params)
    },
    // 2020/11/19 --------------------------------------------------------------------------- 2020/11/19
    // 获取总部/门店/业务员铺券汇总列表
    GET_CARDSALESSTATISTICSLIST(params) {
        return api.fetch('post', `${customize}/cardSalesStatistics/getCardSalesStatisticsList`, params)
    },
    // 获取总部/门店/业务员铺券汇总信息下载地址
    GET_URLFORCARDSALESSTATISTICSLIST(params) {
        return api.fetch('post', `${customize}/cardSalesStatistics/getUrlForCardSalesStatisticsList`, params)
    },
    // 获取总部/门店/业务员/会员分销商铺券汇总详细列表
    GET_CARDSALESSTATISTICSDETAIL(params) {
        return api.fetch('post', `${customize}/cardSalesStatistics/getCardSalesStatisticsDetail`, params)
    },
    // 获取总部/门店/业务员/会员分销商铺券汇总详细下载地址
    GET_URLFORCARDSALESSTATISTICSDETAIL(params) {
        return api.fetch('post', `${customize}/cardSalesStatistics/getUrlForCardSalesStatisticsDetail`, params)
    },
    // 获取会员分销商铺券汇总详细销售状态统计信息（会员分销商端）
    GET_TOTALARDSOFMEMBER(params) {
        return api.fetch('post', `${customize}/cardSalesStatistics/getTotalcardsOfMember`, params)
    },
    // 获取总部/门店券卡流向列表(用于详细列表条件)
    GET_LISTFLOWINFO(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getListFlowinfo`, params)
    },
    // 查询实物商品发货、提货数量统计列表
    GET_GOODSDELIVERYLIST(params) {
        return api.fetch('post', `${statistics}/goodsstatistics/getGoodsDeliveryList`, params)
    },
    // 导出实物商品发货、提货数量统计列表
    EXPORTGOODSDELIVERYLIST(params) {
        return api.fetch('post', `${statistics}/goodsstatistics/exportGoodsDeliveryList`, params)
    },
    // 获取顺丰快递产品类型
    GET_EXPRESSTYPELIST(params) {
        return api.fetch('post', `${base}/expressType/getExpressTypeList`, params)
    },
    // 获取券卡激活核销汇总数据列表
    GET_CARDACTANDWRITEOFFSTATISTICS(params) {
        return api.fetch('post', `${base}/statistics/getCardActAndWriteOffStatistics`, params)
    },
    // 获取券卡激活核销汇总导出资源路径
    GET_CARDACTANDWRITEOFFSTATISTICSEXPORTURL(params) {
        return api.fetch('post', `${base}/statistics/getCardActAndWriteOffStatisticsExportURL`, params)
    },
    // 开票金额汇总
    GET_INVOICERECORDSUM(params) {
        return api.fetch('post', `${customize}/invoicerecord/getInvoicerecordSum`, params)
    },
    // 获取常规单列表导出地址
    GET_EXPORTORDERURL(params) {
        return api.fetch('post', `${customize}/saleorder/getExportOrderUrl`, params)
    },
    // 获取门店与门店关联关系
    GET_FLOWRELATION(params) {
        return api.fetch('post', `${customize}/flowinfo/getFlowRelation`, params)
    },
    // 获取关联门店券卡库存（未激活）统计列表
    GET_RELFLOWCARDSTATICS(params) {
        return api.fetch('post', `${customize}/flowinfo/getRelFlowCardStatics`, params)
    },
    //获取关联门店券卡库存（未激活）统计汇总
    GET_RELFLOWCARDSTSTICSSUMMARY(params) {
        return api.fetch('post', `${customize}/flowinfo/getRelFlowCardStaticsSummary`, params)
    },
    // 保存门店与门店关联关系
    SAVEFLOWRELATION(params) {
        return api.fetch('post', `${customize}/flowinfo/saveFlowRelation`, params)
    },
    // 校验上传的文本是否符合绑卡/退卡条件
    CHECKTXTFILE(params) {
        return api.fetch('post', `${customize}/saleorder/checkTxtFile`, params)
    },

    // 开票商品采购明细列表(收发存明细使用)
    GET_PURDETAILLISTBYINVGOODSCODE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getPurdetailListByInvgoodscode`, params)
    },
    // 导出开票商品采购明细列表(收发存明细使用)
    EXPORTPURDETAILLISTBYINVGOODSCODE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/exportPurdetailListByInvgoodscode`, params)
    },
    // 开票申请明细列表(收发存明细使用)
    GET_INVOICELISTBYINVGOODSCODE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/getInvoiceListByInvgoodscode`, params)
    },
    // 导出开票申请明细列表(收发存明细使用)
    EXPORTINVOICELISTBYINVGOODSCODE(params) {
        return api.fetch('post', `${customize}/invgoodsinfo/exportInvoiceListByInvgoodscode`, params)
    },
    //退货申请批量导入券码
    IMPORTCODES(params) {
        return api.fetch('post', `${customize}/paybackapply/importcodes`, params)
    },
    // 销售单下单是否触发控价
    ISNEEDCONTRPRICE(params) {
        return api.fetch('post', `${customize}/contrPriceRisk/isNeedContrPriceOrRiskOrZeroOrder`, params)
    },
    // 获取退款申请列表 —— 退款金额汇总
    GET_APPLYREFUNDAMOUNTSUM(params) {
        return api.fetch('post', `${customize}/paybackapply/getApplyRefundAmountSum`, params)
    },
    // 提货订单类型转换
    CONVERORDERDELIMODE(params) {
        return api.fetch('post', `${order}/order/converOrderDelimode`, params)
    },
    // 根据会员编号获取待收款金额
    GET_AMOUNTFORCOLLECTION(params) {
        return api.fetch('post', `${customize}/account/getAmountForCollection`, params)
    },
    // 会员收款
    MEMBERGATHERING(params) {
        return api.fetch('post', `${customize}/account/memberGathering`, params)
    },
    // 获取销售单 —— 销售金额汇总
    GET_SALEORDERAMOUNTSUM(params) {
        return api.fetch('post', `${customize}/saleorder/getSaleOrderAmountSum`, params)
    },
    // 消费者收付款明细记录列表汇总
    CONSUMERPAYINFOSUM(params) {
        return api.fetch('post', `${customize}/account/consumerPayInfoSum`, params)
    },
    //快递物流信息查询
    GET_EXPRESSINFO(params) {
        return api.fetch('post', `${delivery}/expquery/getExpressinfo`, params)
    },
    // 快递物流信息缓存查询
    GET_CACHEEXPRESSINFO(params) {
        return api.fetch('post', `${delivery}/expquery/getCacheExpressinfo`, params)
    },
    // 快递物流信息缓存查询
    GET_EXPQMANAGEINFO(params) {
        return api.fetch('post', `${delivery}/expquery/getExpqManageInfo`, params)
    },
    // 获取开通的物流列表 用于数据统计
    GET_ZPUSHOWPRINT(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getShowPrint`, params)
    },
    // 达达预下单
    PREPLACEORDER(params) {
        return api.fetch('post', `${cityDelivery}/placeOrder/prePlaceOrder`, params)
    },
    // 达达发单
    AFTERPLACEORDER(params) {
        return api.fetch('post', `${cityDelivery}/placeOrder/afterPlaceOrder`, params)
    },
    // 达达支付下单
    ADDPLACEORDER(params) {
        return api.fetch('post', `${cityDelivery}/placeOrder/addPlaceOrder`, params)
    },
    // 达达订单重发
    REPLACEORDER(params) {
        return api.fetch('post', `${cityDelivery}/placeOrder/rePlaceOrder`, params)
    },
    // 达达订单取消
    FORMALCANCEL(params) {
        return api.fetch('post', `${cityDelivery}/dadaorder/formalCancel`, params)
    },
    // 查询达达订单详情
    GETORDERDETAIL(params) {
        return api.fetch('post', `${cityDelivery}/dadaorder/getOrderDetail`, params)
    },
    // 妥投异常确认收到物品
    CONFIRMGOODS(params) {
        return api.fetch('post', `${cityDelivery}/dadaorder/confirmGoods`, params)
    },
    // 查询达达订单状态变更记录列表
    GETORDSTATECHANGERECORDLIST(params) {
        return api.fetch('post', `${cityDelivery}/dadaorder/getOrdstatechangerecordList`, params)
    },
    // 获取同城订单基础信息列表数据
    GETINTRACITYSERVICEORDERBASELIST(params) {
        return api.fetch('post', `${order}/store/order/getIntraCityServiceOrderBaseList`, params)
    },
    // 获取同城导出订单列表URL
    GETINTRACITYSERVICEORDERWXPORTURL(params) {
        return api.fetch('post', `${order}/store/order/getIntraCityServiceOrderExportUrl`, params)
    },
    // 查询达达订单取消原因列表
    GETCANCEREASONLIST(params) {
        return api.fetch('post', `${cityDelivery}/dadaorder/getCancelReasonList`, params)
    },
    // 2021/11/1 ---------------------------------------------------------------------------------------------------------- 2021/11/1
    // 获取按销售人员统计列表信息 - 即门店的微门店
    GET_SMALLSTORESCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getSmallStoresCardstatisticsList`, params)
    },
    // 获取按销售人员统计列表信息下载地址 - 即门店的微门店
    GET_URLFORSMALLSTORESCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForSmallStoresCardstatisticsList`, params)
    },
    // 获取按销售人员统计的门店券卡流向列表（开通区域总代销售模式专用）
    GET_SMALLSTORESFLOWINFO(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getSmallStoresFlowinfo`, params)
    },
    // 2021/11/5 ----------------------------------------------------------------------------------------------------------- 2021/11/5
    // 销售人员审核
    GET_EXAMINESALESMAN(params) {
        return api.fetch('post', `${base}/flowinfo/examineSalesman`, params)
    },
    // 获取流向列表（无需登录）
    NOLOGIN_GETFLOWLIST(params) {
        return api.fetch('post', `${base}/flowinfo/nologin/getFlowList`, params)
    },
    // 收付款记录修改收付款账号
    UPDATECONSUMERPAYACCOUNT(params) {
        return api.fetch('post', `${customize}/account/updateConsumerpayAccount`, params)
    },
    GET_GETLIST(params) {
        return api.fetch('post', `${scheme}/pubconfiginfo/get/nologin`, params)
    },
    //抖音卡券核销
    COUPONSVERFY(params) {
        return api.fetch('post', `${doudian}/doudian/couponsVerify`, params)
    },
    //抖音卡券详情
    GET_CARDDEDAILS(params) {
        return api.fetch('post', `${doudian}/doudian/getCardDedails`, params)
    },
    // 获取宣传动画分类
    GET_ANICLASSIFYINFOLIST(params) {
        return api.fetch('post', `${anitemplate}/anitemplate/getAniClassifyInfoList`, params)
    },  // 获取个性化宣传模板列表
    GET_ANISETINFOLIST(params) {
        return api.fetch('post', `${anitemplate}/anisetinfo/getAnisetinfoList`, params)
    },// 企业个性化宣传模板详情
    GET_ANISETINFODETAIL(params) {
        return api.fetch('post', `${anitemplate}/anisetinfo/getAnisetinfoDetail`, params)
    },
    //扫码仪录入
    CODESCANNER(params) {
        return api.fetch('post', `${card}/codeinfo/codeScanner`, params)
    },
    //会员资产查询
    GETMEMBERINFO(params) {
        return api.fetch('post', `${base}/onsite/getMemberInfo`, params)
    },
    //会员卡包礼品券列表
    GETCARDLIST(params) {
        return api.fetch('post', `${base}/onsite/getCardList`, params)
    },
    //会员卡包优惠券列表
    GETCOUPONLIST(params) {
        return api.fetch('post', `${base}/onsite/getCouponList`, params)
    },
    //会员资产变更记录
    GETRECORDLIST(params) {
        return api.fetch('post', `${base}/onsite/getRecord`, params)
    },
    //会员礼品券转商城币
    TRUECOINS(params) {
        return api.fetch('post', `${base}/onsite/turnCoins`, params)
    },
    //商城币扣除
    USECOINS(params) {
        return api.fetch('post', `${base}/onsite/useCoins`, params)
    },
    /* S 2023-02-14 DHL 扫码仪设置页面相关接口 */
    // 查询扫码仪列表
    GETCODESCANNERLIST(params) {
      return api.fetch('post', `${base}/codescanner/getCodescannerList`, params)
    },
    // 更新扫码仪状态
    UPDATEONLINESTATUS(params) {
      return api.fetch('post', `${base}/codescanner/changeOnlinestatus`, params)
    },
    // 设置扫码仪工作时间
    SETSCANCODESTIME(params) {
      return api.fetch('post', `${base}/codescanner/setWorktime`, params)
    },
    /* E 2023-02-14 DHL 扫码仪设置页面相关接口 */
    // 获取全局控制
    GET_GLOBALCONFIG(params) {
        return api.fetch('post', `${base}/sysconelementsinfo/getGlobalConfig`, params)
    },
    // 微信登录以及微信账号绑定/解除 --------------------------------------------- 微信登录以及微信账号绑定/解除S 2023/05/12
    //唯一编号获取接口
    GET_UNIQUENUMBER(params) {
        return api.fetch('post', `${common}/getUniqueNumber`, params)
    },
    // 获取带参数的关注二维码
    GET_QRCODEURL(params) {
        return api.fetch('post', `${base}/wechat/getQrCodeUrl`, params)
    },
    // 获取关注二维码扫描结果（管理端扫码登录用）
    GET_SCANRESULT(params) {
        return api.fetch('post', `${base}/wechat/getScanResult`, params)
    },
    // 账号绑定微信
    WXBIND(params) {
        return api.fetch('post', `${base}/wechat/bind`, params)
    },
    // 账号解绑微信
    WXUNBIND(params) {
        return api.fetch('post', `${base}/wechat/unbind`, params)
    },
    // 微信登录以及微信账号绑定/解除 --------------------------------------------- 微信登录以及微信账号绑定/解除E 2023/05/12
    //查询快递/订单
    QUERYLIST(params) {
        return api.fetch('post', `${delivery}/queryOrderAndExp/queryList`, params);
    },
    // 2024/3/5 ----------------------------------------------------------------------------------------- 2024/3/5 批量导入重要客户 S
    // 批量导入重要客户/会员
    IMPORTMEMBERS(params) {
      return api.fetch('post', `${base}/memberService/importMembers`, params)
    },
    // 2024/3/5 ----------------------------------------------------------------------------------------- 2024/3/5 批量导入重要客户 E
    GET_QYDMLIST(params) {
      return api.fetch('post', `${new_delivery}/setting/getQydmList`, params)
    },
    // 获取门店激活自动延长的有效期
    GET_MDACTEXTENDVALIDDATE(params) {
      return api.fetch('post', `${card}/codeinfo/getMdActExtendValiddate`, params)
    },
    // 二级门店派单相关接口 -------------------------------------------------------------------------------------------- 二级门店派单相关接口 2024/07/31 S
    // 一级门店派单操作（派单，取消派单）
    ASSIGNORDER(params) {
        return api.fetch('post', `${order}/store/order/assignOrder`, params)
    },
    // 获取当前门店给二级门店的订单派单记录
    GET_ORDERDESINFORECORDLIST(params) {
        return api.fetch('post', `${order}/store/order/getOrderdesinfoRecordList`, params)
    },
    // 二级门店派单相关接口 -------------------------------------------------------------------------------------------- 二级门店派单相关接口 2024/07/31 E
    // 门店铺券提交接口
    MDPUQUANOPER(params) {
      return api.fetch('post', `${card}/codeinfo/mdPuQuanOper`, params)
    },
    // 2024/7/31 ----------------------------------------------------------------------------------------- 2024/7/31 蟹都汇二级门店 S
    // 获取企业门店余量
    GETSTORENUMBER(params) {
      return api.fetch('post', `${base}/flowinfo/getStoreNumber`, params)
    },
    // 二级门店绑定微门店
    SECFLOWBINDWXFLOW(params) {
      return api.fetch('post', `${base}/flowinfo/secFlowBindWxflow`, params)
    },
    // 查询门店绑定的微门店列表/微门店绑定的门店列表
    GETBINDWXFLOW(params) {
      return api.fetch('post', `${base}/flowinfo/getBindWxflow`, params)
    },
    // 查询指定门店是否绑定发货微门店
    SETFLOWDELIVERWXFLOW(params) {
      return api.fetch('post', `${base}/flowinfo/secFlowDeliverWxflow`, params)
    },
    // 2024/7/31 ----------------------------------------------------------------------------------------- 2024/7/31 蟹都汇二级门店 E
    // 解绑门店会员绑定的微信 ----------------------------------------------------------------------------- 2024/08/26
    MBUNBINDWX(params) {
        return api.fetch('post', `${base}/memberService/unbindWx`, params)
    },
    // 2024/09/02 ------------------------------------------------------------------------------------ 2024/09/02 流向二级门店券卡统计 S
    //获取流向二级门店券卡统计列表信息
    GET_SECFLOWCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getSecFlowCardstatisticsList`, params)
    },
    //获取流向二级门店券卡统计列表信息下载地址
    GET_URLFORSECFLOWCARDSTATISTICSLIST(params) {
        return api.fetch('post', `${statistics}/store/cardstatistics/getUrlForSecFlowCardstatisticsList`, params)
    },
    //获取按二级门店统计的门店券卡流向列表
    GET_SECSTORESFLOWINFO(params) {
        return api.fetch('post', `${statistics}/zpubtypes/getSecStoresFlowinfo`, params)
    },
    // 2024/09/02 ------------------------------------------------------------------------------------ 2024/09/02 流向二级门店券卡统计 E
    // 商品列表导出 --------------------------------------------------------------------------- 2024/09/23
    GET_EXPORTGOODS(params) {
        return api.fetch('post', `${goods}/exportGoods/exportGoods`, params)
    },
    // 批量修改商品销售日期
    BATCHUPDSALEDATE(params) {
        return api.fetch('post', `${goods}/goods/batchUpdSaledate`, params)
    },
    // 批量导入商品 --------------------------------------------------------------------------- 2024/09/23
    IMPORTGOODS(params) {
        return api.fetch('post',`${goods}/goods/importGoods`,params)
    },
    //获取商品扩展属性列表
    GET_EXTENDlIST(params) {
        return api.fetch('post', `${goods}/extend/list`, params)
    },
    //启用/禁用商品扩展属性
    GET_EXTENDCHANGESTATUS(params) {
        return api.fetch('post', `${goods}/extend/changeStatus`, params)
    },
    //删除商品扩展属性（已经被商品使用的不能删除）
    GET_EXTENDDELETE(params) {
        return api.fetch('post', `${goods}/extend/delete`, params)
    },
    // 新增/修改商品扩展属性
    GET_EXTENDSAVE(params) {
        return api.fetch('post', `${goods}/extend/save`, params)
    },
    //追加商品扩展选项值（用于快速添加选项）
    GET_EXTENDAPPEND(params) {
        return api.fetch('post', `${goods}/extend/append`, params)
    },
    // 保存商品（商品规格一起保存）
    SAVEGOODSANDKIND(params) {
        return api.fetch('post', `${goods}/goods/saveGoodsAndKind`, params)
    },
    // 2024/09/24 ----------------------------------------------------------------------------------------- 2024/09/24 蟹都汇经销商对账业务 S
    // 获取门店对账收付款列表信息
    GET_RECPAYACCOUNTSLIST(params) {
        return api.fetch('post', `${xdh}/recpay/getAccountsList`, params)
    },
    // 净额结算明细列表
    GET_NETTINGDETAILLIST(params) {
        return api.fetch('post', `${xdh}/netting/getNettingDetailList`, params)
    },
    // 完成结算
    NETTINGCOMPLETE(params) {
        return api.fetch('post', `${xdh}/netting/complete`, params)
    },
    // 门店对账历史记录列表
    GET_STOREBILLHISTORYLIST(params) {
        return api.fetch('post', `${xdh}/netting/getStoreBillHistoryList`, params)
    },
    // 获取门店列表
    GET_FLOWINFOLIST(params) {
      return api.fetch('post', `${xdh}/getFlowinfoList`, params)
    },
    // 导出门店对账收付款列表信息
    GET_XDHURLFORACCOUNTSLIST(params) {
        return api.fetch('post', `${xdh}/export/getUrlForAccountsList`, params)
    },
    // 导出净额结算明细列表
    GET_URLFORNETTINGDETAILLIST(params) {
        return api.fetch('post', `${xdh}/export/getUrlForNettingDetailList`, params)
    },
    // 导出门店对账历史记录列表
    GET_URLFORSTOREBILLHISTORYLIST(params) {
        return api.fetch('post', `${xdh}/export/getUrlForStoreBillHistoryList`, params)
    },
    // 获取任务列表
    GET_XDHRECORDLIST(params) {
        return api.fetch('post', `${xdh}/export/getRecordList`, params)
    },
    // 获取门店对账报表券卡详细列表
    GET_XDHACCOUNTSCARDDETAIL(params) {
        return api.fetch('post', `${xdh}/recpay/getAccountsCardDetail`, params)
    },
    // 获取门店对账报表券卡详细列表下载地址
    GET_XDHURLFORACCOUNTSCARDDETAIL(params) {
        return api.fetch('post', `${xdh}/export/getUrlForAccountsCardDetail`, params)
    },
    // 2024/09/24 ----------------------------------------------------------------------------------------- 2024/09/24 蟹都汇经销商对账业务 E
    // 2024/10/29 ----------------------------------------------------------------------------------------- 2024/10/29 画宝刚经销商对账业务 S
    // 获取门店对账收付款列表信息
    GET_HBGRECPAYACCOUNTSLIST(params) {
        return api.fetch('post', `${xdh}/hbg/recpay/getAccountsList`, params)
    },
    // 完成结算
    HBGNETTINGCOMPLETE(params) {
        return api.fetch('post', `${xdh}/hbg/netting/complete`, params)
    },
    // 门店对账历史记录列表
    GET_HBGSTOREBILLHISTORYLIST(params) {
        return api.fetch('post', `${xdh}/hbg/netting/getStoreBillHistoryList`, params)
    },
    // 获取门店对账报表券卡详细列表
    GET_HBGACCOUNTSCARDDETAIL(params) {
        return api.fetch('post', `${xdh}/hbg/recpay/getAccountsCardDetail`, params)
    },
    // 2024/10/29 ----------------------------------------------------------------------------------------- 2024/10/29 画宝刚经销商对账业务 E
    // 2024/12/13 ----------------------------------------------------------------------------------------- 2024/12/13 添加会员详情页面查询信息 S
    // 查询积分商城红包以及佣金明细列表
    GET_MARDETAILLIST(params) {
        return api.fetch('post', `${base}/memberService/getMardetailList`, params)
    },
    // 2024/12/13 ----------------------------------------------------------------------------------------- 2024/12/13 添加会员详情页面查询信息 E
    // 获取新京东面单模板列表
    GET_JDTEMPLATELIST(params) {
        return api.fetch('post', `${new_delivery}/operation/getJDTemplateList`, params)
    },
    // 获取新京东面授权信息
    GET_JDAUTH() {
        return apis+'/api/center/new_delivery/operation/auth'
    },
    // 设置默认皮肤-------------------------------------------------------------------------------------------ZLY 2025/01/14 设置皮肤 S
    SETSKIN(params) {
      return api.fetch('post', `${base}/setSkin`, params)
    },
    // 设置默认皮肤-------------------------------------------------------------------------------------------ZLY 2025/01/14 设置皮肤 E
    // 窥探任务列表是否存在正在下载的任务 --------------------------------------------------------------------- 2025/04/09 窥探任务列表是否存在正在下载的任务 S
    ISDOWNLOADING(params) {
        return api.fetch('post', `${statistics}/taskRecord/isDownloading`, params)
    },
    XDHISDOWNLOADING(params) {
        return api.fetch('post', `${xdh}/export/isDownloading`, params)
    },
    // 窥探任务列表是否存在正在下载的任务 --------------------------------------------------------------------- 2025/04/09 窥探任务列表是否存在正在下载的任务 E
    // 激活额度变更记录导出
    GET_DISQUOTALISTEXPORTURL(params) {
        return api.fetch('post', `${base}/flowinfo/getDisquotaListExportUrl`, params)
    },
    // 获取二级门店已激活扣除额度
    GET_ERJIUSEDQUOTA(params) {
      return api.fetch('post', `${base}/flowinfo/getErjiUsedQuota`, params)
    },

    //-------------------------------------------------------------------------------------------2025.08.07 订单发货配置开通订单通知 zly start
    // 订单发货通知订阅地址
    TOBIND(params) {
      return api.fetch('get', `${base}/pubordprint/nologin/toBind`, params)
    },
    // 订单发货通知设置
    SET_ORDNOTICE(params) {
      return api.fetch('post', `${base}/pubordprint/setOrdNotice`, params)
    },
    // 获取已经订阅发货通知的微信用户列表
    GET_ORDNOTICEUSERS(params) {
      return api.fetch('post', `${base}/pubordprint/getOrdNoticeUsers`, params)
    },
    // 移除已经订阅发货通知的微信用户
    REMOVEOPENID(params) {
      return api.fetch('post', `${base}/pubordprint/removeOpenid`, params)
    },
    //-------------------------------------------------------------------------------------------2025.08.07 订单发货配置开通订单通知 zly end
    //获取顺丰快递产品类型
    GET_SFPRODUCTS(params) {
        return api.fetch('post', `${new_delivery}/operation/getSFProducts`, params);
    },
}



// WEBPACK FOOTER //
// ./src/apis/api.js